export const CountriesLanguageList = [
  {
    ID: 1,
    Country: "Djibouti",
    Language: "Afar (Djibouti)",
    TwoLetterISORegionName: "DJ",
    ThreeLetterISORegionName: "DJI",
    TwoLetterISOLanguageName: "aa",
    ThreeLetterISOLanguageName: "aar",
    CultureInfo: "aa-DJ",
  },
  {
    ID: 2,
    Country: "Eritrea",
    Language: "Afar (Eritrea)",
    TwoLetterISORegionName: "ER",
    ThreeLetterISORegionName: "ERI",
    TwoLetterISOLanguageName: "aa",
    ThreeLetterISOLanguageName: "aar",
    CultureInfo: "aa-ER",
  },
  {
    ID: 3,
    Country: "Ethiopia",
    Language: "Afar (Ethiopia)",
    TwoLetterISORegionName: "ET",
    ThreeLetterISORegionName: "ETH",
    TwoLetterISOLanguageName: "aa",
    ThreeLetterISOLanguageName: "aar",
    CultureInfo: "aa-ET",
  },
  {
    ID: 4,
    Country: "Namibia",
    Language: "Afrikaans (Namibia)",
    TwoLetterISORegionName: "NA",
    ThreeLetterISORegionName: "NAM",
    TwoLetterISOLanguageName: "af",
    ThreeLetterISOLanguageName: "afr",
    CultureInfo: "af-NA",
  },
  {
    ID: 5,
    Country: "South Africa",
    Language: "Afrikaans (South Africa)",
    TwoLetterISORegionName: "ZA",
    ThreeLetterISORegionName: "ZAF",
    TwoLetterISOLanguageName: "af",
    ThreeLetterISOLanguageName: "afr",
    CultureInfo: "af-ZA",
  },
  {
    ID: 6,
    Country: "Cameroon",
    Language: "Aghem (Cameroon)",
    TwoLetterISORegionName: "CM",
    ThreeLetterISORegionName: "CMR",
    TwoLetterISOLanguageName: "agq",
    ThreeLetterISOLanguageName: "agq",
    CultureInfo: "agq-CM",
  },
  {
    ID: 7,
    Country: "Ghana",
    Language: "Akan (Ghana)",
    TwoLetterISORegionName: "GH",
    ThreeLetterISORegionName: "GHA",
    TwoLetterISOLanguageName: "ak",
    ThreeLetterISOLanguageName: "aka",
    CultureInfo: "ak-GH",
  },
  {
    ID: 8,
    Country: "Ethiopia",
    Language: "Amharic (Ethiopia)",
    TwoLetterISORegionName: "ET",
    ThreeLetterISORegionName: "ETH",
    TwoLetterISOLanguageName: "am",
    ThreeLetterISOLanguageName: "amh",
    CultureInfo: "am-ET",
  },
  {
    ID: 9,
    Country: "World",
    Language: "Arabic (World)",
    TwoLetterISORegionName: "001",
    ThreeLetterISORegionName: "",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-001",
  },
  {
    ID: 10,
    Country: "United Arab Emirates",
    Language: "Arabic (United Arab Emirates)",
    TwoLetterISORegionName: "AE",
    ThreeLetterISORegionName: "ARE",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-AE",
  },
  {
    ID: 11,
    Country: "Bahrain",
    Language: "Arabic (Bahrain)",
    TwoLetterISORegionName: "BH",
    ThreeLetterISORegionName: "BHR",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-BH",
  },
  {
    ID: 12,
    Country: "Djibouti",
    Language: "Arabic (Djibouti)",
    TwoLetterISORegionName: "DJ",
    ThreeLetterISORegionName: "DJI",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-DJ",
  },
  {
    ID: 13,
    Country: "Algeria",
    Language: "Arabic (Algeria)",
    TwoLetterISORegionName: "DZ",
    ThreeLetterISORegionName: "DZA",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-DZ",
  },
  {
    ID: 14,
    Country: "Egypt",
    Language: "Arabic (Egypt)",
    TwoLetterISORegionName: "EG",
    ThreeLetterISORegionName: "EGY",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-EG",
  },
  {
    ID: 15,
    Country: "Eritrea",
    Language: "Arabic (Eritrea)",
    TwoLetterISORegionName: "ER",
    ThreeLetterISORegionName: "ERI",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-ER",
  },
  {
    ID: 16,
    Country: "Israel",
    Language: "Arabic (Israel)",
    TwoLetterISORegionName: "IL",
    ThreeLetterISORegionName: "ISR",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-IL",
  },
  {
    ID: 17,
    Country: "Iraq",
    Language: "Arabic (Iraq)",
    TwoLetterISORegionName: "IQ",
    ThreeLetterISORegionName: "IRQ",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-IQ",
  },
  {
    ID: 18,
    Country: "Jordan",
    Language: "Arabic (Jordan)",
    TwoLetterISORegionName: "JO",
    ThreeLetterISORegionName: "JOR",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-JO",
  },
  {
    ID: 19,
    Country: "Comoros",
    Language: "Arabic (Comoros)",
    TwoLetterISORegionName: "KM",
    ThreeLetterISORegionName: "COM",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-KM",
  },
  {
    ID: 20,
    Country: "Kuwait",
    Language: "Arabic (Kuwait)",
    TwoLetterISORegionName: "KW",
    ThreeLetterISORegionName: "KWT",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-KW",
  },
  {
    ID: 21,
    Country: "Lebanon",
    Language: "Arabic (Lebanon)",
    TwoLetterISORegionName: "LB",
    ThreeLetterISORegionName: "LBN",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-LB",
  },
  {
    ID: 22,
    Country: "Libya",
    Language: "Arabic (Libya)",
    TwoLetterISORegionName: "LY",
    ThreeLetterISORegionName: "LBY",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-LY",
  },
  {
    ID: 23,
    Country: "Morocco",
    Language: "Arabic (Morocco)",
    TwoLetterISORegionName: "MA",
    ThreeLetterISORegionName: "MAR",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-MA",
  },
  {
    ID: 24,
    Country: "Mauritania",
    Language: "Arabic (Mauritania)",
    TwoLetterISORegionName: "MR",
    ThreeLetterISORegionName: "MRT",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-MR",
  },
  {
    ID: 25,
    Country: "Oman",
    Language: "Arabic (Oman)",
    TwoLetterISORegionName: "OM",
    ThreeLetterISORegionName: "OMN",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-OM",
  },
  {
    ID: 26,
    Country: "Palestinian Authority",
    Language: "Arabic (Palestinian Authority)",
    TwoLetterISORegionName: "PS",
    ThreeLetterISORegionName: "PSE",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-PS",
  },
  {
    ID: 27,
    Country: "Qatar",
    Language: "Arabic (Qatar)",
    TwoLetterISORegionName: "QA",
    ThreeLetterISORegionName: "QAT",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-QA",
  },
  {
    ID: 28,
    Country: "Saudi Arabia",
    Language: "Arabic (Saudi Arabia)",
    TwoLetterISORegionName: "SA",
    ThreeLetterISORegionName: "SAU",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-SA",
  },
  {
    ID: 29,
    Country: "Sudan",
    Language: "Arabic (Sudan)",
    TwoLetterISORegionName: "SD",
    ThreeLetterISORegionName: "SDN",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-SD",
  },
  {
    ID: 30,
    Country: "Somalia",
    Language: "Arabic (Somalia)",
    TwoLetterISORegionName: "SO",
    ThreeLetterISORegionName: "SOM",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-SO",
  },
  {
    ID: 31,
    Country: "South Sudan",
    Language: "Arabic (South Sudan)",
    TwoLetterISORegionName: "SS",
    ThreeLetterISORegionName: "SSD",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-SS",
  },
  {
    ID: 32,
    Country: "Syria",
    Language: "Arabic (Syria)",
    TwoLetterISORegionName: "SY",
    ThreeLetterISORegionName: "SYR",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-SY",
  },
  {
    ID: 33,
    Country: "Chad",
    Language: "Arabic (Chad)",
    TwoLetterISORegionName: "TD",
    ThreeLetterISORegionName: "TCD",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-TD",
  },
  {
    ID: 34,
    Country: "Tunisia",
    Language: "Arabic (Tunisia)",
    TwoLetterISORegionName: "TN",
    ThreeLetterISORegionName: "TUN",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-TN",
  },
  {
    ID: 35,
    Country: "Yemen",
    Language: "Arabic (Yemen)",
    TwoLetterISORegionName: "YE",
    ThreeLetterISORegionName: "YEM",
    TwoLetterISOLanguageName: "ar",
    ThreeLetterISOLanguageName: "ara",
    CultureInfo: "ar-YE",
  },
  {
    ID: 36,
    Country: "Chile",
    Language: "Mapuche (Chile)",
    TwoLetterISORegionName: "CL",
    ThreeLetterISORegionName: "CHL",
    TwoLetterISOLanguageName: "arn",
    ThreeLetterISOLanguageName: "arn",
    CultureInfo: "arn-CL",
  },
  {
    ID: 37,
    Country: "India",
    Language: "Assamese (India)",
    TwoLetterISORegionName: "IN",
    ThreeLetterISORegionName: "IND",
    TwoLetterISOLanguageName: "as",
    ThreeLetterISOLanguageName: "asm",
    CultureInfo: "as-IN",
  },
  {
    ID: 38,
    Country: "Tanzania",
    Language: "Asu (Tanzania)",
    TwoLetterISORegionName: "TZ",
    ThreeLetterISORegionName: "TZA",
    TwoLetterISOLanguageName: "asa",
    ThreeLetterISOLanguageName: "asa",
    CultureInfo: "asa-TZ",
  },
  {
    ID: 39,
    Country: "Spain",
    Language: "Asturian (Spain)",
    TwoLetterISORegionName: "ES",
    ThreeLetterISORegionName: "ESP",
    TwoLetterISOLanguageName: "ast",
    ThreeLetterISOLanguageName: "ast",
    CultureInfo: "ast-ES",
  },
  {
    ID: 40,
    Country: "Azerbaijan",
    Language: "Azerbaijani (Cyrillic, Azerbaijan)",
    TwoLetterISORegionName: "AZ",
    ThreeLetterISORegionName: "AZE",
    TwoLetterISOLanguageName: "az",
    ThreeLetterISOLanguageName: "aze",
    CultureInfo: "az-Cyrl-AZ",
  },
  {
    ID: 41,
    Country: "Azerbaijan",
    Language: "Azerbaijani (Latin, Azerbaijan)",
    TwoLetterISORegionName: "AZ",
    ThreeLetterISORegionName: "AZE",
    TwoLetterISOLanguageName: "az",
    ThreeLetterISOLanguageName: "aze",
    CultureInfo: "az-Latn-AZ",
  },
  {
    ID: 42,
    Country: "Russia",
    Language: "Bashkir (Russia)",
    TwoLetterISORegionName: "RU",
    ThreeLetterISORegionName: "RUS",
    TwoLetterISOLanguageName: "ba",
    ThreeLetterISOLanguageName: "bak",
    CultureInfo: "ba-RU",
  },
  {
    ID: 43,
    Country: "Cameroon",
    Language: "Basaa (Cameroon)",
    TwoLetterISORegionName: "CM",
    ThreeLetterISORegionName: "CMR",
    TwoLetterISOLanguageName: "bas",
    ThreeLetterISOLanguageName: "bas",
    CultureInfo: "bas-CM",
  },
  {
    ID: 44,
    Country: "Belarus",
    Language: "Belarusian (Belarus)",
    TwoLetterISORegionName: "BY",
    ThreeLetterISORegionName: "BLR",
    TwoLetterISOLanguageName: "be",
    ThreeLetterISOLanguageName: "bel",
    CultureInfo: "be-BY",
  },
  {
    ID: 45,
    Country: "Zambia",
    Language: "Bemba (Zambia)",
    TwoLetterISORegionName: "ZM",
    ThreeLetterISORegionName: "ZMB",
    TwoLetterISOLanguageName: "bem",
    ThreeLetterISOLanguageName: "bem",
    CultureInfo: "bem-ZM",
  },
  {
    ID: 46,
    Country: "Tanzania",
    Language: "Bena (Tanzania)",
    TwoLetterISORegionName: "TZ",
    ThreeLetterISORegionName: "TZA",
    TwoLetterISOLanguageName: "bez",
    ThreeLetterISOLanguageName: "bez",
    CultureInfo: "bez-TZ",
  },
  {
    ID: 47,
    Country: "Bulgaria",
    Language: "Bulgarian (Bulgaria)",
    TwoLetterISORegionName: "BG",
    ThreeLetterISORegionName: "BGR",
    TwoLetterISOLanguageName: "bg",
    ThreeLetterISOLanguageName: "bul",
    CultureInfo: "bg-BG",
  },
  {
    ID: 48,
    Country: "Mali",
    Language: "Bamanankan (Mali)",
    TwoLetterISORegionName: "ML",
    ThreeLetterISORegionName: "MLI",
    TwoLetterISOLanguageName: "bm",
    ThreeLetterISOLanguageName: "bam",
    CultureInfo: "bm-ML",
  },
  {
    ID: 49,
    Country: "Bangladesh",
    Language: "Bangla (Bangladesh)",
    TwoLetterISORegionName: "BD",
    ThreeLetterISORegionName: "BGD",
    TwoLetterISOLanguageName: "bn",
    ThreeLetterISOLanguageName: "ben",
    CultureInfo: "bn-BD",
  },
  {
    ID: 50,
    Country: "India",
    Language: "Bangla (India)",
    TwoLetterISORegionName: "IN",
    ThreeLetterISORegionName: "IND",
    TwoLetterISOLanguageName: "bn",
    ThreeLetterISOLanguageName: "ben",
    CultureInfo: "bn-IN",
  },
  {
    ID: 51,
    Country: "China",
    Language: "Tibetan (China)",
    TwoLetterISORegionName: "CN",
    ThreeLetterISORegionName: "CHN",
    TwoLetterISOLanguageName: "bo",
    ThreeLetterISOLanguageName: "bod",
    CultureInfo: "bo-CN",
  },
  {
    ID: 52,
    Country: "India",
    Language: "Tibetan (India)",
    TwoLetterISORegionName: "IN",
    ThreeLetterISORegionName: "IND",
    TwoLetterISOLanguageName: "bo",
    ThreeLetterISOLanguageName: "bod",
    CultureInfo: "bo-IN",
  },
  {
    ID: 53,
    Country: "France",
    Language: "Breton (France)",
    TwoLetterISORegionName: "FR",
    ThreeLetterISORegionName: "FRA",
    TwoLetterISOLanguageName: "br",
    ThreeLetterISOLanguageName: "bre",
    CultureInfo: "br-FR",
  },
  {
    ID: 54,
    Country: "India",
    Language: "Bodo (India)",
    TwoLetterISORegionName: "IN",
    ThreeLetterISORegionName: "IND",
    TwoLetterISOLanguageName: "brx",
    ThreeLetterISOLanguageName: "brx",
    CultureInfo: "brx-IN",
  },
  {
    ID: 55,
    Country: "Bosnia &amp; Herzegovina",
    Language: "Bosnian (Cyrillic, Bosnia &amp; Herzegovina)",
    TwoLetterISORegionName: "BA",
    ThreeLetterISORegionName: "BIH",
    TwoLetterISOLanguageName: "bs",
    ThreeLetterISOLanguageName: "bos",
    CultureInfo: "bs-Cyrl-BA",
  },
  {
    ID: 56,
    Country: "Bosnia &amp; Herzegovina",
    Language: "Bosnian (Latin, Bosnia &amp; Herzegovina)",
    TwoLetterISORegionName: "BA",
    ThreeLetterISORegionName: "BIH",
    TwoLetterISOLanguageName: "bs",
    ThreeLetterISOLanguageName: "bos",
    CultureInfo: "bs-Latn-BA",
  },
  {
    ID: 57,
    Country: "Eritrea",
    Language: "Blin (Eritrea)",
    TwoLetterISORegionName: "ER",
    ThreeLetterISORegionName: "ERI",
    TwoLetterISOLanguageName: "byn",
    ThreeLetterISOLanguageName: "byn",
    CultureInfo: "byn-ER",
  },
  {
    ID: 58,
    Country: "Andorra",
    Language: "Catalan (Andorra)",
    TwoLetterISORegionName: "AD",
    ThreeLetterISORegionName: "AND",
    TwoLetterISOLanguageName: "ca",
    ThreeLetterISOLanguageName: "cat",
    CultureInfo: "ca-AD",
  },
  {
    ID: 59,
    Country: "Spain",
    Language: "Catalan (Spain)",
    TwoLetterISORegionName: "ES",
    ThreeLetterISORegionName: "ESP",
    TwoLetterISOLanguageName: "ca",
    ThreeLetterISOLanguageName: "cat",
    CultureInfo: "ca-ES",
  },
  {
    ID: 60,
    Country: "Spain",
    Language: "Catalan (Spain, Valencian)",
    TwoLetterISORegionName: "ES",
    ThreeLetterISORegionName: "ESP",
    TwoLetterISOLanguageName: "ca",
    ThreeLetterISOLanguageName: "cat",
    CultureInfo: "ca-ES-VALENCIA",
  },
  {
    ID: 61,
    Country: "France",
    Language: "Catalan (France)",
    TwoLetterISORegionName: "FR",
    ThreeLetterISORegionName: "FRA",
    TwoLetterISOLanguageName: "ca",
    ThreeLetterISOLanguageName: "cat",
    CultureInfo: "ca-FR",
  },
  {
    ID: 62,
    Country: "Italy",
    Language: "Catalan (Italy)",
    TwoLetterISORegionName: "IT",
    ThreeLetterISORegionName: "ITA",
    TwoLetterISOLanguageName: "ca",
    ThreeLetterISOLanguageName: "cat",
    CultureInfo: "ca-IT",
  },
  {
    ID: 63,
    Country: "Bangladesh",
    Language: "Chakma (Bangladesh)",
    TwoLetterISORegionName: "BD",
    ThreeLetterISORegionName: "BGD",
    TwoLetterISOLanguageName: "ccp",
    ThreeLetterISOLanguageName: "ccp",
    CultureInfo: "ccp-BD",
  },
  {
    ID: 64,
    Country: "India",
    Language: "Chakma (India)",
    TwoLetterISORegionName: "IN",
    ThreeLetterISORegionName: "IND",
    TwoLetterISOLanguageName: "ccp",
    ThreeLetterISOLanguageName: "ccp",
    CultureInfo: "ccp-IN",
  },
  {
    ID: 65,
    Country: "Russia",
    Language: "Chechen (Russia)",
    TwoLetterISORegionName: "RU",
    ThreeLetterISORegionName: "RUS",
    TwoLetterISOLanguageName: "ce",
    ThreeLetterISOLanguageName: "che",
    CultureInfo: "ce-RU",
  },
  {
    ID: 66,
    Country: "Philippines",
    Language: "Cebuano (Philippines)",
    TwoLetterISORegionName: "PH",
    ThreeLetterISORegionName: "PHL",
    TwoLetterISOLanguageName: "ceb",
    ThreeLetterISOLanguageName: "ceb",
    CultureInfo: "ceb-PH",
  },
  {
    ID: 67,
    Country: "Uganda",
    Language: "Chiga (Uganda)",
    TwoLetterISORegionName: "UG",
    ThreeLetterISORegionName: "UGA",
    TwoLetterISOLanguageName: "cgg",
    ThreeLetterISOLanguageName: "cgg",
    CultureInfo: "cgg-UG",
  },
  {
    ID: 68,
    Country: "United States",
    Language: "Cherokee (United States)",
    TwoLetterISORegionName: "US",
    ThreeLetterISORegionName: "USA",
    TwoLetterISOLanguageName: "chr",
    ThreeLetterISOLanguageName: "chr",
    CultureInfo: "chr-US",
  },
  {
    ID: 69,
    Country: "Iraq",
    Language: "Central Kurdish (Iraq)",
    TwoLetterISORegionName: "IQ",
    ThreeLetterISORegionName: "IRQ",
    TwoLetterISOLanguageName: "ckb",
    ThreeLetterISOLanguageName: "ckb",
    CultureInfo: "ckb-IQ",
  },
  {
    ID: 70,
    Country: "Iran",
    Language: "Central Kurdish (Iran)",
    TwoLetterISORegionName: "IR",
    ThreeLetterISORegionName: "IRN",
    TwoLetterISOLanguageName: "ckb",
    ThreeLetterISOLanguageName: "ckb",
    CultureInfo: "ckb-IR",
  },
  {
    ID: 71,
    Country: "France",
    Language: "Corsican (France)",
    TwoLetterISORegionName: "FR",
    ThreeLetterISORegionName: "FRA",
    TwoLetterISOLanguageName: "co",
    ThreeLetterISOLanguageName: "cos",
    CultureInfo: "co-FR",
  },
  {
    ID: 72,
    Country: "Czechia",
    Language: "Czech (Czechia)",
    TwoLetterISORegionName: "CZ",
    ThreeLetterISORegionName: "CZE",
    TwoLetterISOLanguageName: "cs",
    ThreeLetterISOLanguageName: "ces",
    CultureInfo: "cs-CZ",
  },
  {
    ID: 73,
    Country: "Russia",
    Language: "Church Slavic (Russia)",
    TwoLetterISORegionName: "RU",
    ThreeLetterISORegionName: "RUS",
    TwoLetterISOLanguageName: "cu",
    ThreeLetterISOLanguageName: "chu",
    CultureInfo: "cu-RU",
  },
  {
    ID: 74,
    Country: "United Kingdom",
    Language: "Welsh (United Kingdom)",
    TwoLetterISORegionName: "GB",
    ThreeLetterISORegionName: "GBR",
    TwoLetterISOLanguageName: "cy",
    ThreeLetterISOLanguageName: "cym",
    CultureInfo: "cy-GB",
  },
  {
    ID: 75,
    Country: "Denmark",
    Language: "Danish (Denmark)",
    TwoLetterISORegionName: "DK",
    ThreeLetterISORegionName: "DNK",
    TwoLetterISOLanguageName: "da",
    ThreeLetterISOLanguageName: "dan",
    CultureInfo: "da-DK",
  },
  {
    ID: 76,
    Country: "Greenland",
    Language: "Danish (Greenland)",
    TwoLetterISORegionName: "GL",
    ThreeLetterISORegionName: "GRL",
    TwoLetterISOLanguageName: "da",
    ThreeLetterISOLanguageName: "dan",
    CultureInfo: "da-GL",
  },
  {
    ID: 77,
    Country: "Kenya",
    Language: "Taita (Kenya)",
    TwoLetterISORegionName: "KE",
    ThreeLetterISORegionName: "KEN",
    TwoLetterISOLanguageName: "dav",
    ThreeLetterISOLanguageName: "dav",
    CultureInfo: "dav-KE",
  },
  {
    ID: 78,
    Country: "Austria",
    Language: "German (Austria)",
    TwoLetterISORegionName: "AT",
    ThreeLetterISORegionName: "AUT",
    TwoLetterISOLanguageName: "de",
    ThreeLetterISOLanguageName: "deu",
    CultureInfo: "de-AT",
  },
  {
    ID: 79,
    Country: "Belgium",
    Language: "German (Belgium)",
    TwoLetterISORegionName: "BE",
    ThreeLetterISORegionName: "BEL",
    TwoLetterISOLanguageName: "de",
    ThreeLetterISOLanguageName: "deu",
    CultureInfo: "de-BE",
  },
  {
    ID: 80,
    Country: "Switzerland",
    Language: "German (Switzerland)",
    TwoLetterISORegionName: "CH",
    ThreeLetterISORegionName: "CHE",
    TwoLetterISOLanguageName: "de",
    ThreeLetterISOLanguageName: "deu",
    CultureInfo: "de-CH",
  },
  {
    ID: 81,
    Country: "Germany",
    Language: "German (Germany)",
    TwoLetterISORegionName: "DE",
    ThreeLetterISORegionName: "DEU",
    TwoLetterISOLanguageName: "de",
    ThreeLetterISOLanguageName: "deu",
    CultureInfo: "de-DE",
  },
  {
    ID: 82,
    Country: "Italy",
    Language: "German (Italy)",
    TwoLetterISORegionName: "IT",
    ThreeLetterISORegionName: "ITA",
    TwoLetterISOLanguageName: "de",
    ThreeLetterISOLanguageName: "deu",
    CultureInfo: "de-IT",
  },
  {
    ID: 83,
    Country: "Liechtenstein",
    Language: "German (Liechtenstein)",
    TwoLetterISORegionName: "LI",
    ThreeLetterISORegionName: "LIE",
    TwoLetterISOLanguageName: "de",
    ThreeLetterISOLanguageName: "deu",
    CultureInfo: "de-LI",
  },
  {
    ID: 84,
    Country: "Luxembourg",
    Language: "German (Luxembourg)",
    TwoLetterISORegionName: "LU",
    ThreeLetterISORegionName: "LUX",
    TwoLetterISOLanguageName: "de",
    ThreeLetterISOLanguageName: "deu",
    CultureInfo: "de-LU",
  },
  {
    ID: 85,
    Country: "Niger",
    Language: "Zarma (Niger)",
    TwoLetterISORegionName: "NE",
    ThreeLetterISORegionName: "NER",
    TwoLetterISOLanguageName: "dje",
    ThreeLetterISOLanguageName: "dje",
    CultureInfo: "dje-NE",
  },
  {
    ID: 86,
    Country: "Germany",
    Language: "Lower Sorbian (Germany)",
    TwoLetterISORegionName: "DE",
    ThreeLetterISORegionName: "DEU",
    TwoLetterISOLanguageName: "dsb",
    ThreeLetterISOLanguageName: "dsb",
    CultureInfo: "dsb-DE",
  },
  {
    ID: 87,
    Country: "Cameroon",
    Language: "Duala (Cameroon)",
    TwoLetterISORegionName: "CM",
    ThreeLetterISORegionName: "CMR",
    TwoLetterISOLanguageName: "dua",
    ThreeLetterISOLanguageName: "dua",
    CultureInfo: "dua-CM",
  },
  {
    ID: 88,
    Country: "Maldives",
    Language: "Divehi (Maldives)",
    TwoLetterISORegionName: "MV",
    ThreeLetterISORegionName: "MDV",
    TwoLetterISOLanguageName: "dv",
    ThreeLetterISOLanguageName: "div",
    CultureInfo: "dv-MV",
  },
  {
    ID: 89,
    Country: "Senegal",
    Language: "Jola-Fonyi (Senegal)",
    TwoLetterISORegionName: "SN",
    ThreeLetterISORegionName: "SEN",
    TwoLetterISOLanguageName: "dyo",
    ThreeLetterISOLanguageName: "dyo",
    CultureInfo: "dyo-SN",
  },
  {
    ID: 90,
    Country: "Bhutan",
    Language: "Dzongkha (Bhutan)",
    TwoLetterISORegionName: "BT",
    ThreeLetterISORegionName: "BTN",
    TwoLetterISOLanguageName: "dz",
    ThreeLetterISOLanguageName: "dzo",
    CultureInfo: "dz-BT",
  },
  {
    ID: 91,
    Country: "Kenya",
    Language: "Embu (Kenya)",
    TwoLetterISORegionName: "KE",
    ThreeLetterISORegionName: "KEN",
    TwoLetterISOLanguageName: "ebu",
    ThreeLetterISOLanguageName: "ebu",
    CultureInfo: "ebu-KE",
  },
  {
    ID: 92,
    Country: "Ghana",
    Language: "Ewe (Ghana)",
    TwoLetterISORegionName: "GH",
    ThreeLetterISORegionName: "GHA",
    TwoLetterISOLanguageName: "ee",
    ThreeLetterISOLanguageName: "ewe",
    CultureInfo: "ee-GH",
  },
  {
    ID: 93,
    Country: "Togo",
    Language: "Ewe (Togo)",
    TwoLetterISORegionName: "TG",
    ThreeLetterISORegionName: "TGO",
    TwoLetterISOLanguageName: "ee",
    ThreeLetterISOLanguageName: "ewe",
    CultureInfo: "ee-TG",
  },
  {
    ID: 94,
    Country: "Cyprus",
    Language: "Greek (Cyprus)",
    TwoLetterISORegionName: "CY",
    ThreeLetterISORegionName: "CYP",
    TwoLetterISOLanguageName: "el",
    ThreeLetterISOLanguageName: "ell",
    CultureInfo: "el-CY",
  },
  {
    ID: 95,
    Country: "Greece",
    Language: "Greek (Greece)",
    TwoLetterISORegionName: "GR",
    ThreeLetterISORegionName: "GRC",
    TwoLetterISOLanguageName: "el",
    ThreeLetterISOLanguageName: "ell",
    CultureInfo: "el-GR",
  },
  {
    ID: 96,
    Country: "World",
    Language: "English (World)",
    TwoLetterISORegionName: "001",
    ThreeLetterISORegionName: "",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-001",
  },
  {
    ID: 97,
    Country: "Europe",
    Language: "English (Europe)",
    TwoLetterISORegionName: 150,
    ThreeLetterISORegionName: "",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-150",
  },
  {
    ID: 98,
    Country: "United Arab Emirates",
    Language: "English (United Arab Emirates)",
    TwoLetterISORegionName: "AE",
    ThreeLetterISORegionName: "ARE",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-AE",
  },
  {
    ID: 99,
    Country: "Antigua &amp; Barbuda",
    Language: "English (Antigua &amp; Barbuda)",
    TwoLetterISORegionName: "AG",
    ThreeLetterISORegionName: "ATG",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-AG",
  },
  {
    ID: 100,
    Country: "Anguilla",
    Language: "English (Anguilla)",
    TwoLetterISORegionName: "AI",
    ThreeLetterISORegionName: "AIA",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-AI",
  },
  {
    ID: 101,
    Country: "American Samoa",
    Language: "English (American Samoa)",
    TwoLetterISORegionName: "AS",
    ThreeLetterISORegionName: "ASM",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-AS",
  },
  {
    ID: 102,
    Country: "Austria",
    Language: "English (Austria)",
    TwoLetterISORegionName: "AT",
    ThreeLetterISORegionName: "AUT",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-AT",
  },
  {
    ID: 103,
    Country: "Australia",
    Language: "English (Australia)",
    TwoLetterISORegionName: "AU",
    ThreeLetterISORegionName: "AUS",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-AU",
  },
  {
    ID: 104,
    Country: "Barbados",
    Language: "English (Barbados)",
    TwoLetterISORegionName: "BB",
    ThreeLetterISORegionName: "BRB",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-BB",
  },
  {
    ID: 105,
    Country: "Belgium",
    Language: "English (Belgium)",
    TwoLetterISORegionName: "BE",
    ThreeLetterISORegionName: "BEL",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-BE",
  },
  {
    ID: 106,
    Country: "Burundi",
    Language: "English (Burundi)",
    TwoLetterISORegionName: "BI",
    ThreeLetterISORegionName: "BDI",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-BI",
  },
  {
    ID: 107,
    Country: "Bermuda",
    Language: "English (Bermuda)",
    TwoLetterISORegionName: "BM",
    ThreeLetterISORegionName: "BMU",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-BM",
  },
  {
    ID: 108,
    Country: "Bahamas",
    Language: "English (Bahamas)",
    TwoLetterISORegionName: "BS",
    ThreeLetterISORegionName: "BHS",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-BS",
  },
  {
    ID: 109,
    Country: "Botswana",
    Language: "English (Botswana)",
    TwoLetterISORegionName: "BW",
    ThreeLetterISORegionName: "BWA",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-BW",
  },
  {
    ID: 110,
    Country: "Belize",
    Language: "English (Belize)",
    TwoLetterISORegionName: "BZ",
    ThreeLetterISORegionName: "BLZ",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-BZ",
  },
  {
    ID: 111,
    Country: "Canada",
    Language: "English (Canada)",
    TwoLetterISORegionName: "CA",
    ThreeLetterISORegionName: "CAN",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-CA",
  },
  {
    ID: 112,
    Country: "Cocos (Keeling) Islands",
    Language: "English (Cocos [Keeling] Islands)",
    TwoLetterISORegionName: "CC",
    ThreeLetterISORegionName: "CCK",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-CC",
  },
  {
    ID: 113,
    Country: "Switzerland",
    Language: "English (Switzerland)",
    TwoLetterISORegionName: "CH",
    ThreeLetterISORegionName: "CHE",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-CH",
  },
  {
    ID: 114,
    Country: "Cook Islands",
    Language: "English (Cook Islands)",
    TwoLetterISORegionName: "CK",
    ThreeLetterISORegionName: "COK",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-CK",
  },
  {
    ID: 115,
    Country: "Cameroon",
    Language: "English (Cameroon)",
    TwoLetterISORegionName: "CM",
    ThreeLetterISORegionName: "CMR",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-CM",
  },
  {
    ID: 116,
    Country: "Christmas Island",
    Language: "English (Christmas Island)",
    TwoLetterISORegionName: "CX",
    ThreeLetterISORegionName: "CXR",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-CX",
  },
  {
    ID: 117,
    Country: "Cyprus",
    Language: "English (Cyprus)",
    TwoLetterISORegionName: "CY",
    ThreeLetterISORegionName: "CYP",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-CY",
  },
  {
    ID: 118,
    Country: "Germany",
    Language: "English (Germany)",
    TwoLetterISORegionName: "DE",
    ThreeLetterISORegionName: "DEU",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-DE",
  },
  {
    ID: 119,
    Country: "Denmark",
    Language: "English (Denmark)",
    TwoLetterISORegionName: "DK",
    ThreeLetterISORegionName: "DNK",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-DK",
  },
  {
    ID: 120,
    Country: "Dominica",
    Language: "English (Dominica)",
    TwoLetterISORegionName: "DM",
    ThreeLetterISORegionName: "DMA",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-DM",
  },
  {
    ID: 121,
    Country: "Eritrea",
    Language: "English (Eritrea)",
    TwoLetterISORegionName: "ER",
    ThreeLetterISORegionName: "ERI",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-ER",
  },
  {
    ID: 122,
    Country: "Finland",
    Language: "English (Finland)",
    TwoLetterISORegionName: "FI",
    ThreeLetterISORegionName: "FIN",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-FI",
  },
  {
    ID: 123,
    Country: "Fiji",
    Language: "English (Fiji)",
    TwoLetterISORegionName: "FJ",
    ThreeLetterISORegionName: "FJI",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-FJ",
  },
  {
    ID: 124,
    Country: "Falkland Islands",
    Language: "English (Falkland Islands)",
    TwoLetterISORegionName: "FK",
    ThreeLetterISORegionName: "FLK",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-FK",
  },
  {
    ID: 125,
    Country: "Micronesia",
    Language: "English (Micronesia)",
    TwoLetterISORegionName: "FM",
    ThreeLetterISORegionName: "FSM",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-FM",
  },
  {
    ID: 126,
    Country: "United Kingdom",
    Language: "English (United Kingdom)",
    TwoLetterISORegionName: "GB",
    ThreeLetterISORegionName: "GBR",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-GB",
  },
  {
    ID: 127,
    Country: "Grenada",
    Language: "English (Grenada)",
    TwoLetterISORegionName: "GD",
    ThreeLetterISORegionName: "GRD",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-GD",
  },
  {
    ID: 128,
    Country: "Guernsey",
    Language: "English (Guernsey)",
    TwoLetterISORegionName: "GG",
    ThreeLetterISORegionName: "GGY",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-GG",
  },
  {
    ID: 129,
    Country: "Ghana",
    Language: "English (Ghana)",
    TwoLetterISORegionName: "GH",
    ThreeLetterISORegionName: "GHA",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-GH",
  },
  {
    ID: 130,
    Country: "Gibraltar",
    Language: "English (Gibraltar)",
    TwoLetterISORegionName: "GI",
    ThreeLetterISORegionName: "GIB",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-GI",
  },
  {
    ID: 131,
    Country: "Gambia",
    Language: "English (Gambia)",
    TwoLetterISORegionName: "GM",
    ThreeLetterISORegionName: "GMB",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-GM",
  },
  {
    ID: 132,
    Country: "Guam",
    Language: "English (Guam)",
    TwoLetterISORegionName: "GU",
    ThreeLetterISORegionName: "GUM",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-GU",
  },
  {
    ID: 133,
    Country: "Guyana",
    Language: "English (Guyana)",
    TwoLetterISORegionName: "GY",
    ThreeLetterISORegionName: "GUY",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-GY",
  },
  {
    ID: 134,
    Country: "Hong Kong SAR",
    Language: "English (Hong Kong SAR)",
    TwoLetterISORegionName: "HK",
    ThreeLetterISORegionName: "HKG",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-HK",
  },
  {
    ID: 135,
    Country: "Ireland",
    Language: "English (Ireland)",
    TwoLetterISORegionName: "IE",
    ThreeLetterISORegionName: "IRL",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-IE",
  },
  {
    ID: 136,
    Country: "Israel",
    Language: "English (Israel)",
    TwoLetterISORegionName: "IL",
    ThreeLetterISORegionName: "ISR",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-IL",
  },
  {
    ID: 137,
    Country: "Isle of Man",
    Language: "English (Isle of Man)",
    TwoLetterISORegionName: "IM",
    ThreeLetterISORegionName: "IMN",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-IM",
  },
  {
    ID: 138,
    Country: "India",
    Language: "English (India)",
    TwoLetterISORegionName: "IN",
    ThreeLetterISORegionName: "IND",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-IN",
  },
  {
    ID: 139,
    Country: "British Indian Ocean Territory",
    Language: "English (British Indian Ocean Territory)",
    TwoLetterISORegionName: "IO",
    ThreeLetterISORegionName: "IOT",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-IO",
  },
  {
    ID: 140,
    Country: "Jersey",
    Language: "English (Jersey)",
    TwoLetterISORegionName: "JE",
    ThreeLetterISORegionName: "JEY",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-JE",
  },
  {
    ID: 141,
    Country: "Jamaica",
    Language: "English (Jamaica)",
    TwoLetterISORegionName: "JM",
    ThreeLetterISORegionName: "JAM",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-JM",
  },
  {
    ID: 142,
    Country: "Kenya",
    Language: "English (Kenya)",
    TwoLetterISORegionName: "KE",
    ThreeLetterISORegionName: "KEN",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-KE",
  },
  {
    ID: 143,
    Country: "Kiribati",
    Language: "English (Kiribati)",
    TwoLetterISORegionName: "KI",
    ThreeLetterISORegionName: "KIR",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-KI",
  },
  {
    ID: 144,
    Country: "St. Kitts &amp; Nevis",
    Language: "English (St. Kitts &amp; Nevis)",
    TwoLetterISORegionName: "KN",
    ThreeLetterISORegionName: "KNA",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-KN",
  },
  {
    ID: 145,
    Country: "Cayman Islands",
    Language: "English (Cayman Islands)",
    TwoLetterISORegionName: "KY",
    ThreeLetterISORegionName: "CYM",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-KY",
  },
  {
    ID: 146,
    Country: "St. Lucia",
    Language: "English (St. Lucia)",
    TwoLetterISORegionName: "LC",
    ThreeLetterISORegionName: "LCA",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-LC",
  },
  {
    ID: 147,
    Country: "Liberia",
    Language: "English (Liberia)",
    TwoLetterISORegionName: "LR",
    ThreeLetterISORegionName: "LBR",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-LR",
  },
  {
    ID: 148,
    Country: "Lesotho",
    Language: "English (Lesotho)",
    TwoLetterISORegionName: "LS",
    ThreeLetterISORegionName: "LSO",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-LS",
  },
  {
    ID: 149,
    Country: "Madagascar",
    Language: "English (Madagascar)",
    TwoLetterISORegionName: "MG",
    ThreeLetterISORegionName: "MDG",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-MG",
  },
  {
    ID: 150,
    Country: "Marshall Islands",
    Language: "English (Marshall Islands)",
    TwoLetterISORegionName: "MH",
    ThreeLetterISORegionName: "MHL",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-MH",
  },
  {
    ID: 151,
    Country: "Macao SAR",
    Language: "English (Macao SAR)",
    TwoLetterISORegionName: "MO",
    ThreeLetterISORegionName: "MAC",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-MO",
  },
  {
    ID: 152,
    Country: "Northern Mariana Islands",
    Language: "English (Northern Mariana Islands)",
    TwoLetterISORegionName: "MP",
    ThreeLetterISORegionName: "MNP",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-MP",
  },
  {
    ID: 153,
    Country: "Montserrat",
    Language: "English (Montserrat)",
    TwoLetterISORegionName: "MS",
    ThreeLetterISORegionName: "MSR",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-MS",
  },
  {
    ID: 154,
    Country: "Malta",
    Language: "English (Malta)",
    TwoLetterISORegionName: "MT",
    ThreeLetterISORegionName: "MLT",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-MT",
  },
  {
    ID: 155,
    Country: "Mauritius",
    Language: "English (Mauritius)",
    TwoLetterISORegionName: "MU",
    ThreeLetterISORegionName: "MUS",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-MU",
  },
  {
    ID: 156,
    Country: "Malawi",
    Language: "English (Malawi)",
    TwoLetterISORegionName: "MW",
    ThreeLetterISORegionName: "MWI",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-MW",
  },
  {
    ID: 157,
    Country: "Malaysia",
    Language: "English (Malaysia)",
    TwoLetterISORegionName: "MY",
    ThreeLetterISORegionName: "MYS",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-MY",
  },
  {
    ID: 158,
    Country: "Namibia",
    Language: "English (Namibia)",
    TwoLetterISORegionName: "NA",
    ThreeLetterISORegionName: "NAM",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-NA",
  },
  {
    ID: 159,
    Country: "Norfolk Island",
    Language: "English (Norfolk Island)",
    TwoLetterISORegionName: "NF",
    ThreeLetterISORegionName: "NFK",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-NF",
  },
  {
    ID: 160,
    Country: "Nigeria",
    Language: "English (Nigeria)",
    TwoLetterISORegionName: "NG",
    ThreeLetterISORegionName: "NGA",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-NG",
  },
  {
    ID: 161,
    Country: "Netherlands",
    Language: "English (Netherlands)",
    TwoLetterISORegionName: "NL",
    ThreeLetterISORegionName: "NLD",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-NL",
  },
  {
    ID: 162,
    Country: "Nauru",
    Language: "English (Nauru)",
    TwoLetterISORegionName: "NR",
    ThreeLetterISORegionName: "NRU",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-NR",
  },
  {
    ID: 163,
    Country: "Niue",
    Language: "English (Niue)",
    TwoLetterISORegionName: "NU",
    ThreeLetterISORegionName: "NIU",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-NU",
  },
  {
    ID: 164,
    Country: "New Zealand",
    Language: "English (New Zealand)",
    TwoLetterISORegionName: "NZ",
    ThreeLetterISORegionName: "NZL",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-NZ",
  },
  {
    ID: 165,
    Country: "Papua New Guinea",
    Language: "English (Papua New Guinea)",
    TwoLetterISORegionName: "PG",
    ThreeLetterISORegionName: "PNG",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-PG",
  },
  {
    ID: 166,
    Country: "Philippines",
    Language: "English (Philippines)",
    TwoLetterISORegionName: "PH",
    ThreeLetterISORegionName: "PHL",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-PH",
  },
  {
    ID: 167,
    Country: "Pakistan",
    Language: "English (Pakistan)",
    TwoLetterISORegionName: "PK",
    ThreeLetterISORegionName: "PAK",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-PK",
  },
  {
    ID: 168,
    Country: "Pitcairn Islands",
    Language: "English (Pitcairn Islands)",
    TwoLetterISORegionName: "PN",
    ThreeLetterISORegionName: "PCN",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-PN",
  },
  {
    ID: 169,
    Country: "Puerto Rico",
    Language: "English (Puerto Rico)",
    TwoLetterISORegionName: "PR",
    ThreeLetterISORegionName: "PRI",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-PR",
  },
  {
    ID: 170,
    Country: "Palau",
    Language: "English (Palau)",
    TwoLetterISORegionName: "PW",
    ThreeLetterISORegionName: "PLW",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-PW",
  },
  {
    ID: 171,
    Country: "Rwanda",
    Language: "English (Rwanda)",
    TwoLetterISORegionName: "RW",
    ThreeLetterISORegionName: "RWA",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-RW",
  },
  {
    ID: 172,
    Country: "Solomon Islands",
    Language: "English (Solomon Islands)",
    TwoLetterISORegionName: "SB",
    ThreeLetterISORegionName: "SLB",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-SB",
  },
  {
    ID: 173,
    Country: "Seychelles",
    Language: "English (Seychelles)",
    TwoLetterISORegionName: "SC",
    ThreeLetterISORegionName: "SYC",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-SC",
  },
  {
    ID: 174,
    Country: "Sudan",
    Language: "English (Sudan)",
    TwoLetterISORegionName: "SD",
    ThreeLetterISORegionName: "SDN",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-SD",
  },
  {
    ID: 175,
    Country: "Sweden",
    Language: "English (Sweden)",
    TwoLetterISORegionName: "SE",
    ThreeLetterISORegionName: "SWE",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-SE",
  },
  {
    ID: 176,
    Country: "Singapore",
    Language: "English (Singapore)",
    TwoLetterISORegionName: "SG",
    ThreeLetterISORegionName: "SGP",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-SG",
  },
  {
    ID: 177,
    Country: "St Helena, Ascension, Tristan da Cunha",
    Language: "English (St Helena, Ascension, Tristan da Cunha)",
    TwoLetterISORegionName: "SH",
    ThreeLetterISORegionName: "SHN",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-SH",
  },
  {
    ID: 178,
    Country: "Slovenia",
    Language: "English (Slovenia)",
    TwoLetterISORegionName: "SI",
    ThreeLetterISORegionName: "SVN",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-SI",
  },
  {
    ID: 179,
    Country: "Sierra Leone",
    Language: "English (Sierra Leone)",
    TwoLetterISORegionName: "SL",
    ThreeLetterISORegionName: "SLE",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-SL",
  },
  {
    ID: 180,
    Country: "South Sudan",
    Language: "English (South Sudan)",
    TwoLetterISORegionName: "SS",
    ThreeLetterISORegionName: "SSD",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-SS",
  },
  {
    ID: 181,
    Country: "Sint Maarten",
    Language: "English (Sint Maarten)",
    TwoLetterISORegionName: "SX",
    ThreeLetterISORegionName: "SXM",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-SX",
  },
  {
    ID: 182,
    Country: "Eswatini",
    Language: "English (Eswatini)",
    TwoLetterISORegionName: "SZ",
    ThreeLetterISORegionName: "SWZ",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-SZ",
  },
  {
    ID: 183,
    Country: "Turks &amp; Caicos Islands",
    Language: "English (Turks &amp; Caicos Islands)",
    TwoLetterISORegionName: "TC",
    ThreeLetterISORegionName: "TCA",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-TC",
  },
  {
    ID: 184,
    Country: "Tokelau",
    Language: "English (Tokelau)",
    TwoLetterISORegionName: "TK",
    ThreeLetterISORegionName: "TKL",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-TK",
  },
  {
    ID: 185,
    Country: "Tonga",
    Language: "English (Tonga)",
    TwoLetterISORegionName: "TO",
    ThreeLetterISORegionName: "TON",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-TO",
  },
  {
    ID: 186,
    Country: "Trinidad &amp; Tobago",
    Language: "English (Trinidad &amp; Tobago)",
    TwoLetterISORegionName: "TT",
    ThreeLetterISORegionName: "TTO",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-TT",
  },
  {
    ID: 187,
    Country: "Tuvalu",
    Language: "English (Tuvalu)",
    TwoLetterISORegionName: "TV",
    ThreeLetterISORegionName: "TUV",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-TV",
  },
  {
    ID: 188,
    Country: "Tanzania",
    Language: "English (Tanzania)",
    TwoLetterISORegionName: "TZ",
    ThreeLetterISORegionName: "TZA",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-TZ",
  },
  {
    ID: 189,
    Country: "Uganda",
    Language: "English (Uganda)",
    TwoLetterISORegionName: "UG",
    ThreeLetterISORegionName: "UGA",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-UG",
  },
  {
    ID: 190,
    Country: "U.S. Outlying Islands",
    Language: "English (U.S. Outlying Islands)",
    TwoLetterISORegionName: "UM",
    ThreeLetterISORegionName: "UMI",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-UM",
  },
  {
    ID: 191,
    Country: "United States",
    Language: "English (United States)",
    TwoLetterISORegionName: "US",
    ThreeLetterISORegionName: "USA",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-US",
  },
  {
    ID: 192,
    Country: "United States",
    Language: "English (United States, Computer)",
    TwoLetterISORegionName: "US",
    ThreeLetterISORegionName: "USA",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-US-POSIX",
  },
  {
    ID: 193,
    Country: "St. Vincent &amp; Grenadines",
    Language: "English (St. Vincent &amp; Grenadines)",
    TwoLetterISORegionName: "VC",
    ThreeLetterISORegionName: "VCT",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-VC",
  },
  {
    ID: 194,
    Country: "British Virgin Islands",
    Language: "English (British Virgin Islands)",
    TwoLetterISORegionName: "VG",
    ThreeLetterISORegionName: "VGB",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-VG",
  },
  {
    ID: 195,
    Country: "U.S. Virgin Islands",
    Language: "English (U.S. Virgin Islands)",
    TwoLetterISORegionName: "VI",
    ThreeLetterISORegionName: "VIR",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-VI",
  },
  {
    ID: 196,
    Country: "Vanuatu",
    Language: "English (Vanuatu)",
    TwoLetterISORegionName: "VU",
    ThreeLetterISORegionName: "VUT",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-VU",
  },
  {
    ID: 197,
    Country: "Samoa",
    Language: "English (Samoa)",
    TwoLetterISORegionName: "WS",
    ThreeLetterISORegionName: "WSM",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-WS",
  },
  {
    ID: 198,
    Country: "South Africa",
    Language: "English (South Africa)",
    TwoLetterISORegionName: "ZA",
    ThreeLetterISORegionName: "ZAF",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-ZA",
  },
  {
    ID: 199,
    Country: "Zambia",
    Language: "English (Zambia)",
    TwoLetterISORegionName: "ZM",
    ThreeLetterISORegionName: "ZMB",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-ZM",
  },
  {
    ID: 200,
    Country: "Zimbabwe",
    Language: "English (Zimbabwe)",
    TwoLetterISORegionName: "ZW",
    ThreeLetterISORegionName: "ZWE",
    TwoLetterISOLanguageName: "en",
    ThreeLetterISOLanguageName: "eng",
    CultureInfo: "en-ZW",
  },
  {
    ID: 201,
    Country: "World",
    Language: "Esperanto (World)",
    TwoLetterISORegionName: "001",
    ThreeLetterISORegionName: "",
    TwoLetterISOLanguageName: "eo",
    ThreeLetterISOLanguageName: "epo",
    CultureInfo: "eo-001",
  },
  {
    ID: 202,
    Country: "Latin America",
    Language: "Spanish (Latin America)",
    TwoLetterISORegionName: 419,
    ThreeLetterISORegionName: "",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-419",
  },
  {
    ID: 203,
    Country: "Argentina",
    Language: "Spanish (Argentina)",
    TwoLetterISORegionName: "AR",
    ThreeLetterISORegionName: "ARG",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-AR",
  },
  {
    ID: 204,
    Country: "Bolivia",
    Language: "Spanish (Bolivia)",
    TwoLetterISORegionName: "BO",
    ThreeLetterISORegionName: "BOL",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-BO",
  },
  {
    ID: 205,
    Country: "Brazil",
    Language: "Spanish (Brazil)",
    TwoLetterISORegionName: "BR",
    ThreeLetterISORegionName: "BRA",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-BR",
  },
  {
    ID: 206,
    Country: "Belize",
    Language: "Spanish (Belize)",
    TwoLetterISORegionName: "BZ",
    ThreeLetterISORegionName: "BLZ",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-BZ",
  },
  {
    ID: 207,
    Country: "Chile",
    Language: "Spanish (Chile)",
    TwoLetterISORegionName: "CL",
    ThreeLetterISORegionName: "CHL",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-CL",
  },
  {
    ID: 208,
    Country: "Colombia",
    Language: "Spanish (Colombia)",
    TwoLetterISORegionName: "CO",
    ThreeLetterISORegionName: "COL",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-CO",
  },
  {
    ID: 209,
    Country: "Costa Rica",
    Language: "Spanish (Costa Rica)",
    TwoLetterISORegionName: "CR",
    ThreeLetterISORegionName: "CRI",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-CR",
  },
  {
    ID: 210,
    Country: "Cuba",
    Language: "Spanish (Cuba)",
    TwoLetterISORegionName: "CU",
    ThreeLetterISORegionName: "CUB",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-CU",
  },
  {
    ID: 211,
    Country: "Dominican Republic",
    Language: "Spanish (Dominican Republic)",
    TwoLetterISORegionName: "DO",
    ThreeLetterISORegionName: "DOM",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-DO",
  },
  {
    ID: 212,
    Country: "Ecuador",
    Language: "Spanish (Ecuador)",
    TwoLetterISORegionName: "EC",
    ThreeLetterISORegionName: "ECU",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-EC",
  },
  {
    ID: 213,
    Country: "Spain",
    Language: "Spanish (Spain)",
    TwoLetterISORegionName: "ES",
    ThreeLetterISORegionName: "ESP",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-ES",
  },
  {
    ID: 214,
    Country: "Equatorial Guinea",
    Language: "Spanish (Equatorial Guinea)",
    TwoLetterISORegionName: "GQ",
    ThreeLetterISORegionName: "GNQ",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-GQ",
  },
  {
    ID: 215,
    Country: "Guatemala",
    Language: "Spanish (Guatemala)",
    TwoLetterISORegionName: "GT",
    ThreeLetterISORegionName: "GTM",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-GT",
  },
  {
    ID: 216,
    Country: "Honduras",
    Language: "Spanish (Honduras)",
    TwoLetterISORegionName: "HN",
    ThreeLetterISORegionName: "HND",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-HN",
  },
  {
    ID: 217,
    Country: "Mexico",
    Language: "Spanish (Mexico)",
    TwoLetterISORegionName: "MX",
    ThreeLetterISORegionName: "MEX",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-MX",
  },
  {
    ID: 218,
    Country: "Nicaragua",
    Language: "Spanish (Nicaragua)",
    TwoLetterISORegionName: "NI",
    ThreeLetterISORegionName: "NIC",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-NI",
  },
  {
    ID: 219,
    Country: "Panama",
    Language: "Spanish (Panama)",
    TwoLetterISORegionName: "PA",
    ThreeLetterISORegionName: "PAN",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-PA",
  },
  {
    ID: 220,
    Country: "Peru",
    Language: "Spanish (Peru)",
    TwoLetterISORegionName: "PE",
    ThreeLetterISORegionName: "PER",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-PE",
  },
  {
    ID: 221,
    Country: "Philippines",
    Language: "Spanish (Philippines)",
    TwoLetterISORegionName: "PH",
    ThreeLetterISORegionName: "PHL",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-PH",
  },
  {
    ID: 222,
    Country: "Puerto Rico",
    Language: "Spanish (Puerto Rico)",
    TwoLetterISORegionName: "PR",
    ThreeLetterISORegionName: "PRI",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-PR",
  },
  {
    ID: 223,
    Country: "Paraguay",
    Language: "Spanish (Paraguay)",
    TwoLetterISORegionName: "PY",
    ThreeLetterISORegionName: "PRY",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-PY",
  },
  {
    ID: 224,
    Country: "El Salvador",
    Language: "Spanish (El Salvador)",
    TwoLetterISORegionName: "SV",
    ThreeLetterISORegionName: "SLV",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-SV",
  },
  {
    ID: 225,
    Country: "United States",
    Language: "Spanish (United States)",
    TwoLetterISORegionName: "US",
    ThreeLetterISORegionName: "USA",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-US",
  },
  {
    ID: 226,
    Country: "Uruguay",
    Language: "Spanish (Uruguay)",
    TwoLetterISORegionName: "UY",
    ThreeLetterISORegionName: "URY",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-UY",
  },
  {
    ID: 227,
    Country: "Venezuela",
    Language: "Spanish (Venezuela)",
    TwoLetterISORegionName: "VE",
    ThreeLetterISORegionName: "VEN",
    TwoLetterISOLanguageName: "es",
    ThreeLetterISOLanguageName: "spa",
    CultureInfo: "es-VE",
  },
  {
    ID: 228,
    Country: "Estonia",
    Language: "Estonian (Estonia)",
    TwoLetterISORegionName: "EE",
    ThreeLetterISORegionName: "EST",
    TwoLetterISOLanguageName: "et",
    ThreeLetterISOLanguageName: "est",
    CultureInfo: "et-EE",
  },
  {
    ID: 229,
    Country: "Spain",
    Language: "Basque (Spain)",
    TwoLetterISORegionName: "ES",
    ThreeLetterISORegionName: "ESP",
    TwoLetterISOLanguageName: "eu",
    ThreeLetterISOLanguageName: "eus",
    CultureInfo: "eu-ES",
  },
  {
    ID: 230,
    Country: "Cameroon",
    Language: "Ewondo (Cameroon)",
    TwoLetterISORegionName: "CM",
    ThreeLetterISORegionName: "CMR",
    TwoLetterISOLanguageName: "ewo",
    ThreeLetterISOLanguageName: "ewo",
    CultureInfo: "ewo-CM",
  },
  {
    ID: 231,
    Country: "Afghanistan",
    Language: "Persian (Afghanistan)",
    TwoLetterISORegionName: "AF",
    ThreeLetterISORegionName: "AFG",
    TwoLetterISOLanguageName: "fa",
    ThreeLetterISOLanguageName: "fas",
    CultureInfo: "fa-AF",
  },
  {
    ID: 232,
    Country: "Iran",
    Language: "Persian (Iran)",
    TwoLetterISORegionName: "IR",
    ThreeLetterISORegionName: "IRN",
    TwoLetterISOLanguageName: "fa",
    ThreeLetterISOLanguageName: "fas",
    CultureInfo: "fa-IR",
  },
  {
    ID: 233,
    Country: "Burkina Faso",
    Language: "Fulah (Latin, Burkina Faso)",
    TwoLetterISORegionName: "BF",
    ThreeLetterISORegionName: "BFA",
    TwoLetterISOLanguageName: "ff",
    ThreeLetterISOLanguageName: "ful",
    CultureInfo: "ff-Latn-BF",
  },
  {
    ID: 234,
    Country: "Cameroon",
    Language: "Fulah (Latin, Cameroon)",
    TwoLetterISORegionName: "CM",
    ThreeLetterISORegionName: "CMR",
    TwoLetterISOLanguageName: "ff",
    ThreeLetterISOLanguageName: "ful",
    CultureInfo: "ff-Latn-CM",
  },
  {
    ID: 235,
    Country: "Ghana",
    Language: "Fulah (Latin, Ghana)",
    TwoLetterISORegionName: "GH",
    ThreeLetterISORegionName: "GHA",
    TwoLetterISOLanguageName: "ff",
    ThreeLetterISOLanguageName: "ful",
    CultureInfo: "ff-Latn-GH",
  },
  {
    ID: 236,
    Country: "Gambia",
    Language: "Fulah (Latin, Gambia)",
    TwoLetterISORegionName: "GM",
    ThreeLetterISORegionName: "GMB",
    TwoLetterISOLanguageName: "ff",
    ThreeLetterISOLanguageName: "ful",
    CultureInfo: "ff-Latn-GM",
  },
  {
    ID: 237,
    Country: "Guinea",
    Language: "Fulah (Latin, Guinea)",
    TwoLetterISORegionName: "GN",
    ThreeLetterISORegionName: "GIN",
    TwoLetterISOLanguageName: "ff",
    ThreeLetterISOLanguageName: "ful",
    CultureInfo: "ff-Latn-GN",
  },
  {
    ID: 238,
    Country: "Guinea-Bissau",
    Language: "Fulah (Latin, Guinea-Bissau)",
    TwoLetterISORegionName: "GW",
    ThreeLetterISORegionName: "GNB",
    TwoLetterISOLanguageName: "ff",
    ThreeLetterISOLanguageName: "ful",
    CultureInfo: "ff-Latn-GW",
  },
  {
    ID: 239,
    Country: "Liberia",
    Language: "Fulah (Latin, Liberia)",
    TwoLetterISORegionName: "LR",
    ThreeLetterISORegionName: "LBR",
    TwoLetterISOLanguageName: "ff",
    ThreeLetterISOLanguageName: "ful",
    CultureInfo: "ff-Latn-LR",
  },
  {
    ID: 240,
    Country: "Mauritania",
    Language: "Fulah (Latin, Mauritania)",
    TwoLetterISORegionName: "MR",
    ThreeLetterISORegionName: "MRT",
    TwoLetterISOLanguageName: "ff",
    ThreeLetterISOLanguageName: "ful",
    CultureInfo: "ff-Latn-MR",
  },
  {
    ID: 241,
    Country: "Niger",
    Language: "Fulah (Latin, Niger)",
    TwoLetterISORegionName: "NE",
    ThreeLetterISORegionName: "NER",
    TwoLetterISOLanguageName: "ff",
    ThreeLetterISOLanguageName: "ful",
    CultureInfo: "ff-Latn-NE",
  },
  {
    ID: 242,
    Country: "Nigeria",
    Language: "Fulah (Latin, Nigeria)",
    TwoLetterISORegionName: "NG",
    ThreeLetterISORegionName: "NGA",
    TwoLetterISOLanguageName: "ff",
    ThreeLetterISOLanguageName: "ful",
    CultureInfo: "ff-Latn-NG",
  },
  {
    ID: 243,
    Country: "Sierra Leone",
    Language: "Fulah (Latin, Sierra Leone)",
    TwoLetterISORegionName: "SL",
    ThreeLetterISORegionName: "SLE",
    TwoLetterISOLanguageName: "ff",
    ThreeLetterISOLanguageName: "ful",
    CultureInfo: "ff-Latn-SL",
  },
  {
    ID: 244,
    Country: "Senegal",
    Language: "Fulah (Latin, Senegal)",
    TwoLetterISORegionName: "SN",
    ThreeLetterISORegionName: "SEN",
    TwoLetterISOLanguageName: "ff",
    ThreeLetterISOLanguageName: "ful",
    CultureInfo: "ff-Latn-SN",
  },
  {
    ID: 245,
    Country: "Finland",
    Language: "Finnish (Finland)",
    TwoLetterISORegionName: "FI",
    ThreeLetterISORegionName: "FIN",
    TwoLetterISOLanguageName: "fi",
    ThreeLetterISOLanguageName: "fin",
    CultureInfo: "fi-FI",
  },
  {
    ID: 246,
    Country: "Philippines",
    Language: "Filipino (Philippines)",
    TwoLetterISORegionName: "PH",
    ThreeLetterISORegionName: "PHL",
    TwoLetterISOLanguageName: "fil",
    ThreeLetterISOLanguageName: "fil",
    CultureInfo: "fil-PH",
  },
  {
    ID: 247,
    Country: "Denmark",
    Language: "Faroese (Denmark)",
    TwoLetterISORegionName: "DK",
    ThreeLetterISORegionName: "DNK",
    TwoLetterISOLanguageName: "fo",
    ThreeLetterISOLanguageName: "fao",
    CultureInfo: "fo-DK",
  },
  {
    ID: 248,
    Country: "Faroe Islands",
    Language: "Faroese (Faroe Islands)",
    TwoLetterISORegionName: "FO",
    ThreeLetterISORegionName: "FRO",
    TwoLetterISOLanguageName: "fo",
    ThreeLetterISOLanguageName: "fao",
    CultureInfo: "fo-FO",
  },
  {
    ID: 249,
    Country: "Belgium",
    Language: "French (Belgium)",
    TwoLetterISORegionName: "BE",
    ThreeLetterISORegionName: "BEL",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-BE",
  },
  {
    ID: 250,
    Country: "Burkina Faso",
    Language: "French (Burkina Faso)",
    TwoLetterISORegionName: "BF",
    ThreeLetterISORegionName: "BFA",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-BF",
  },
  {
    ID: 251,
    Country: "Burundi",
    Language: "French (Burundi)",
    TwoLetterISORegionName: "BI",
    ThreeLetterISORegionName: "BDI",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-BI",
  },
  {
    ID: 252,
    Country: "Benin",
    Language: "French (Benin)",
    TwoLetterISORegionName: "BJ",
    ThreeLetterISORegionName: "BEN",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-BJ",
  },
  {
    ID: 253,
    Country: "St. Barth&#233;lemy",
    Language: "French (St. Barth&#233;lemy)",
    TwoLetterISORegionName: "BL",
    ThreeLetterISORegionName: "BLM",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-BL",
  },
  {
    ID: 254,
    Country: "Canada",
    Language: "French (Canada)",
    TwoLetterISORegionName: "CA",
    ThreeLetterISORegionName: "CAN",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-CA",
  },
  {
    ID: 255,
    Country: "Congo (DRC)",
    Language: "French (Congo [DRC])",
    TwoLetterISORegionName: "CD",
    ThreeLetterISORegionName: "COD",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-CD",
  },
  {
    ID: 256,
    Country: "Central African Republic",
    Language: "French (Central African Republic)",
    TwoLetterISORegionName: "CF",
    ThreeLetterISORegionName: "CAF",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-CF",
  },
  {
    ID: 257,
    Country: "Congo",
    Language: "French (Congo)",
    TwoLetterISORegionName: "CG",
    ThreeLetterISORegionName: "COG",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-CG",
  },
  {
    ID: 258,
    Country: "Switzerland",
    Language: "French (Switzerland)",
    TwoLetterISORegionName: "CH",
    ThreeLetterISORegionName: "CHE",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-CH",
  },
  {
    ID: 259,
    Country: "C&#244;te d’Ivoire",
    Language: "French (C&#244;te d’Ivoire)",
    TwoLetterISORegionName: "CI",
    ThreeLetterISORegionName: "CIV",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-CI",
  },
  {
    ID: 260,
    Country: "Cameroon",
    Language: "French (Cameroon)",
    TwoLetterISORegionName: "CM",
    ThreeLetterISORegionName: "CMR",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-CM",
  },
  {
    ID: 261,
    Country: "Djibouti",
    Language: "French (Djibouti)",
    TwoLetterISORegionName: "DJ",
    ThreeLetterISORegionName: "DJI",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-DJ",
  },
  {
    ID: 262,
    Country: "Algeria",
    Language: "French (Algeria)",
    TwoLetterISORegionName: "DZ",
    ThreeLetterISORegionName: "DZA",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-DZ",
  },
  {
    ID: 263,
    Country: "France",
    Language: "French (France)",
    TwoLetterISORegionName: "FR",
    ThreeLetterISORegionName: "FRA",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-FR",
  },
  {
    ID: 264,
    Country: "Gabon",
    Language: "French (Gabon)",
    TwoLetterISORegionName: "GA",
    ThreeLetterISORegionName: "GAB",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-GA",
  },
  {
    ID: 265,
    Country: "French Guiana",
    Language: "French (French Guiana)",
    TwoLetterISORegionName: "GF",
    ThreeLetterISORegionName: "GUF",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-GF",
  },
  {
    ID: 266,
    Country: "Guinea",
    Language: "French (Guinea)",
    TwoLetterISORegionName: "GN",
    ThreeLetterISORegionName: "GIN",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-GN",
  },
  {
    ID: 267,
    Country: "Guadeloupe",
    Language: "French (Guadeloupe)",
    TwoLetterISORegionName: "GP",
    ThreeLetterISORegionName: "GLP",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-GP",
  },
  {
    ID: 268,
    Country: "Equatorial Guinea",
    Language: "French (Equatorial Guinea)",
    TwoLetterISORegionName: "GQ",
    ThreeLetterISORegionName: "GNQ",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-GQ",
  },
  {
    ID: 269,
    Country: "Haiti",
    Language: "French (Haiti)",
    TwoLetterISORegionName: "HT",
    ThreeLetterISORegionName: "HTI",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-HT",
  },
  {
    ID: 270,
    Country: "Comoros",
    Language: "French (Comoros)",
    TwoLetterISORegionName: "KM",
    ThreeLetterISORegionName: "COM",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-KM",
  },
  {
    ID: 271,
    Country: "Luxembourg",
    Language: "French (Luxembourg)",
    TwoLetterISORegionName: "LU",
    ThreeLetterISORegionName: "LUX",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-LU",
  },
  {
    ID: 272,
    Country: "Morocco",
    Language: "French (Morocco)",
    TwoLetterISORegionName: "MA",
    ThreeLetterISORegionName: "MAR",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-MA",
  },
  {
    ID: 273,
    Country: "Monaco",
    Language: "French (Monaco)",
    TwoLetterISORegionName: "MC",
    ThreeLetterISORegionName: "MCO",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-MC",
  },
  {
    ID: 274,
    Country: "St. Martin",
    Language: "French (St. Martin)",
    TwoLetterISORegionName: "MF",
    ThreeLetterISORegionName: "MAF",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-MF",
  },
  {
    ID: 275,
    Country: "Madagascar",
    Language: "French (Madagascar)",
    TwoLetterISORegionName: "MG",
    ThreeLetterISORegionName: "MDG",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-MG",
  },
  {
    ID: 276,
    Country: "Mali",
    Language: "French (Mali)",
    TwoLetterISORegionName: "ML",
    ThreeLetterISORegionName: "MLI",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-ML",
  },
  {
    ID: 277,
    Country: "Martinique",
    Language: "French (Martinique)",
    TwoLetterISORegionName: "MQ",
    ThreeLetterISORegionName: "MTQ",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-MQ",
  },
  {
    ID: 278,
    Country: "Mauritania",
    Language: "French (Mauritania)",
    TwoLetterISORegionName: "MR",
    ThreeLetterISORegionName: "MRT",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-MR",
  },
  {
    ID: 279,
    Country: "Mauritius",
    Language: "French (Mauritius)",
    TwoLetterISORegionName: "MU",
    ThreeLetterISORegionName: "MUS",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-MU",
  },
  {
    ID: 280,
    Country: "New Caledonia",
    Language: "French (New Caledonia)",
    TwoLetterISORegionName: "NC",
    ThreeLetterISORegionName: "NCL",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-NC",
  },
  {
    ID: 281,
    Country: "Niger",
    Language: "French (Niger)",
    TwoLetterISORegionName: "NE",
    ThreeLetterISORegionName: "NER",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-NE",
  },
  {
    ID: 282,
    Country: "French Polynesia",
    Language: "French (French Polynesia)",
    TwoLetterISORegionName: "PF",
    ThreeLetterISORegionName: "PYF",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-PF",
  },
  {
    ID: 283,
    Country: "St. Pierre &amp; Miquelon",
    Language: "French (St. Pierre &amp; Miquelon)",
    TwoLetterISORegionName: "PM",
    ThreeLetterISORegionName: "SPM",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-PM",
  },
  {
    ID: 284,
    Country: "R&#233;union",
    Language: "French (R&#233;union)",
    TwoLetterISORegionName: "RE",
    ThreeLetterISORegionName: "REU",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-RE",
  },
  {
    ID: 285,
    Country: "Rwanda",
    Language: "French (Rwanda)",
    TwoLetterISORegionName: "RW",
    ThreeLetterISORegionName: "RWA",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-RW",
  },
  {
    ID: 286,
    Country: "Seychelles",
    Language: "French (Seychelles)",
    TwoLetterISORegionName: "SC",
    ThreeLetterISORegionName: "SYC",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-SC",
  },
  {
    ID: 287,
    Country: "Senegal",
    Language: "French (Senegal)",
    TwoLetterISORegionName: "SN",
    ThreeLetterISORegionName: "SEN",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-SN",
  },
  {
    ID: 288,
    Country: "Syria",
    Language: "French (Syria)",
    TwoLetterISORegionName: "SY",
    ThreeLetterISORegionName: "SYR",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-SY",
  },
  {
    ID: 289,
    Country: "Chad",
    Language: "French (Chad)",
    TwoLetterISORegionName: "TD",
    ThreeLetterISORegionName: "TCD",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-TD",
  },
  {
    ID: 290,
    Country: "Togo",
    Language: "French (Togo)",
    TwoLetterISORegionName: "TG",
    ThreeLetterISORegionName: "TGO",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-TG",
  },
  {
    ID: 291,
    Country: "Tunisia",
    Language: "French (Tunisia)",
    TwoLetterISORegionName: "TN",
    ThreeLetterISORegionName: "TUN",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-TN",
  },
  {
    ID: 292,
    Country: "Vanuatu",
    Language: "French (Vanuatu)",
    TwoLetterISORegionName: "VU",
    ThreeLetterISORegionName: "VUT",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-VU",
  },
  {
    ID: 293,
    Country: "Wallis &amp; Futuna",
    Language: "French (Wallis &amp; Futuna)",
    TwoLetterISORegionName: "WF",
    ThreeLetterISORegionName: "WLF",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-WF",
  },
  {
    ID: 294,
    Country: "Mayotte",
    Language: "French (Mayotte)",
    TwoLetterISORegionName: "YT",
    ThreeLetterISORegionName: "MYT",
    TwoLetterISOLanguageName: "fr",
    ThreeLetterISOLanguageName: "fra",
    CultureInfo: "fr-YT",
  },
  {
    ID: 295,
    Country: "Italy",
    Language: "Friulian (Italy)",
    TwoLetterISORegionName: "IT",
    ThreeLetterISORegionName: "ITA",
    TwoLetterISOLanguageName: "fur",
    ThreeLetterISOLanguageName: "fur",
    CultureInfo: "fur-IT",
  },
  {
    ID: 296,
    Country: "Netherlands",
    Language: "Western Frisian (Netherlands)",
    TwoLetterISORegionName: "NL",
    ThreeLetterISORegionName: "NLD",
    TwoLetterISOLanguageName: "fy",
    ThreeLetterISOLanguageName: "fry",
    CultureInfo: "fy-NL",
  },
  {
    ID: 297,
    Country: "Ireland",
    Language: "Irish (Ireland)",
    TwoLetterISORegionName: "IE",
    ThreeLetterISORegionName: "IRL",
    TwoLetterISOLanguageName: "ga",
    ThreeLetterISOLanguageName: "gle",
    CultureInfo: "ga-IE",
  },
  {
    ID: 298,
    Country: "United Kingdom",
    Language: "Scottish Gaelic (United Kingdom)",
    TwoLetterISORegionName: "GB",
    ThreeLetterISORegionName: "GBR",
    TwoLetterISOLanguageName: "gd",
    ThreeLetterISOLanguageName: "gla",
    CultureInfo: "gd-GB",
  },
  {
    ID: 299,
    Country: "Spain",
    Language: "Galician (Spain)",
    TwoLetterISORegionName: "ES",
    ThreeLetterISORegionName: "ESP",
    TwoLetterISOLanguageName: "gl",
    ThreeLetterISOLanguageName: "glg",
    CultureInfo: "gl-ES",
  },
  {
    ID: 300,
    Country: "Paraguay",
    Language: "Guarani (Paraguay)",
    TwoLetterISORegionName: "PY",
    ThreeLetterISORegionName: "PRY",
    TwoLetterISOLanguageName: "gn",
    ThreeLetterISOLanguageName: "grn",
    CultureInfo: "gn-PY",
  },
  {
    ID: 301,
    Country: "Switzerland",
    Language: "Swiss German (Switzerland)",
    TwoLetterISORegionName: "CH",
    ThreeLetterISORegionName: "CHE",
    TwoLetterISOLanguageName: "gsw",
    ThreeLetterISOLanguageName: "gsw",
    CultureInfo: "gsw-CH",
  },
  {
    ID: 302,
    Country: "France",
    Language: "Swiss German (France)",
    TwoLetterISORegionName: "FR",
    ThreeLetterISORegionName: "FRA",
    TwoLetterISOLanguageName: "gsw",
    ThreeLetterISOLanguageName: "gsw",
    CultureInfo: "gsw-FR",
  },
  {
    ID: 303,
    Country: "Liechtenstein",
    Language: "Swiss German (Liechtenstein)",
    TwoLetterISORegionName: "LI",
    ThreeLetterISORegionName: "LIE",
    TwoLetterISOLanguageName: "gsw",
    ThreeLetterISOLanguageName: "gsw",
    CultureInfo: "gsw-LI",
  },
  {
    ID: 304,
    Country: "India",
    Language: "Gujarati (India)",
    TwoLetterISORegionName: "IN",
    ThreeLetterISORegionName: "IND",
    TwoLetterISOLanguageName: "gu",
    ThreeLetterISOLanguageName: "guj",
    CultureInfo: "gu-IN",
  },
  {
    ID: 305,
    Country: "Kenya",
    Language: "Gusii (Kenya)",
    TwoLetterISORegionName: "KE",
    ThreeLetterISORegionName: "KEN",
    TwoLetterISOLanguageName: "guz",
    ThreeLetterISOLanguageName: "guz",
    CultureInfo: "guz-KE",
  },
  {
    ID: 306,
    Country: "Isle of Man",
    Language: "Manx (Isle of Man)",
    TwoLetterISORegionName: "IM",
    ThreeLetterISORegionName: "IMN",
    TwoLetterISOLanguageName: "gv",
    ThreeLetterISOLanguageName: "glv",
    CultureInfo: "gv-IM",
  },
  {
    ID: 307,
    Country: "Ghana",
    Language: "Hausa (Ghana)",
    TwoLetterISORegionName: "GH",
    ThreeLetterISORegionName: "GHA",
    TwoLetterISOLanguageName: "ha",
    ThreeLetterISOLanguageName: "hau",
    CultureInfo: "ha-GH",
  },
  {
    ID: 308,
    Country: "Niger",
    Language: "Hausa (Niger)",
    TwoLetterISORegionName: "NE",
    ThreeLetterISORegionName: "NER",
    TwoLetterISOLanguageName: "ha",
    ThreeLetterISOLanguageName: "hau",
    CultureInfo: "ha-NE",
  },
  {
    ID: 309,
    Country: "Nigeria",
    Language: "Hausa (Nigeria)",
    TwoLetterISORegionName: "NG",
    ThreeLetterISORegionName: "NGA",
    TwoLetterISOLanguageName: "ha",
    ThreeLetterISOLanguageName: "hau",
    CultureInfo: "ha-NG",
  },
  {
    ID: 310,
    Country: "United States",
    Language: "Hawaiian (United States)",
    TwoLetterISORegionName: "US",
    ThreeLetterISORegionName: "USA",
    TwoLetterISOLanguageName: "haw",
    ThreeLetterISOLanguageName: "haw",
    CultureInfo: "haw-US",
  },
  {
    ID: 311,
    Country: "Israel",
    Language: "Hebrew (Israel)",
    TwoLetterISORegionName: "IL",
    ThreeLetterISORegionName: "ISR",
    TwoLetterISOLanguageName: "he",
    ThreeLetterISOLanguageName: "heb",
    CultureInfo: "he-IL",
  },
  {
    ID: 312,
    Country: "India",
    Language: "Hindi (India)",
    TwoLetterISORegionName: "IN",
    ThreeLetterISORegionName: "IND",
    TwoLetterISOLanguageName: "hi",
    ThreeLetterISOLanguageName: "hin",
    CultureInfo: "hi-IN",
  },
  {
    ID: 313,
    Country: "Bosnia &amp; Herzegovina",
    Language: "Croatian (Bosnia &amp; Herzegovina)",
    TwoLetterISORegionName: "BA",
    ThreeLetterISORegionName: "BIH",
    TwoLetterISOLanguageName: "hr",
    ThreeLetterISOLanguageName: "hrv",
    CultureInfo: "hr-BA",
  },
  {
    ID: 314,
    Country: "Croatia",
    Language: "Croatian (Croatia)",
    TwoLetterISORegionName: "HR",
    ThreeLetterISORegionName: "HRV",
    TwoLetterISOLanguageName: "hr",
    ThreeLetterISOLanguageName: "hrv",
    CultureInfo: "hr-HR",
  },
  {
    ID: 315,
    Country: "Germany",
    Language: "Upper Sorbian (Germany)",
    TwoLetterISORegionName: "DE",
    ThreeLetterISORegionName: "DEU",
    TwoLetterISOLanguageName: "hsb",
    ThreeLetterISOLanguageName: "hsb",
    CultureInfo: "hsb-DE",
  },
  {
    ID: 316,
    Country: "Hungary",
    Language: "Hungarian (Hungary)",
    TwoLetterISORegionName: "HU",
    ThreeLetterISORegionName: "HUN",
    TwoLetterISOLanguageName: "hu",
    ThreeLetterISOLanguageName: "hun",
    CultureInfo: "hu-HU",
  },
  {
    ID: 317,
    Country: "Armenia",
    Language: "Armenian (Armenia)",
    TwoLetterISORegionName: "AM",
    ThreeLetterISORegionName: "ARM",
    TwoLetterISOLanguageName: "hy",
    ThreeLetterISOLanguageName: "hye",
    CultureInfo: "hy-AM",
  },
  {
    ID: 318,
    Country: "World",
    Language: "Interlingua (World)",
    TwoLetterISORegionName: "001",
    ThreeLetterISORegionName: "",
    TwoLetterISOLanguageName: "ia",
    ThreeLetterISOLanguageName: "ina",
    CultureInfo: "ia-001",
  },
  {
    ID: 319,
    Country: "Indonesia",
    Language: "Indonesian (Indonesia)",
    TwoLetterISORegionName: "ID",
    ThreeLetterISORegionName: "IDN",
    TwoLetterISOLanguageName: "id",
    ThreeLetterISOLanguageName: "ind",
    CultureInfo: "id-ID",
  },
  {
    ID: 320,
    Country: "Nigeria",
    Language: "Igbo (Nigeria)",
    TwoLetterISORegionName: "NG",
    ThreeLetterISORegionName: "NGA",
    TwoLetterISOLanguageName: "ig",
    ThreeLetterISOLanguageName: "ibo",
    CultureInfo: "ig-NG",
  },
  {
    ID: 321,
    Country: "China",
    Language: "Yi (China)",
    TwoLetterISORegionName: "CN",
    ThreeLetterISORegionName: "CHN",
    TwoLetterISOLanguageName: "ii",
    ThreeLetterISOLanguageName: "iii",
    CultureInfo: "ii-CN",
  },
  {
    ID: 322,
    Country: "Iceland",
    Language: "Icelandic (Iceland)",
    TwoLetterISORegionName: "IS",
    ThreeLetterISORegionName: "ISL",
    TwoLetterISOLanguageName: "is",
    ThreeLetterISOLanguageName: "isl",
    CultureInfo: "is-IS",
  },
  {
    ID: 323,
    Country: "Switzerland",
    Language: "Italian (Switzerland)",
    TwoLetterISORegionName: "CH",
    ThreeLetterISORegionName: "CHE",
    TwoLetterISOLanguageName: "it",
    ThreeLetterISOLanguageName: "ita",
    CultureInfo: "it-CH",
  },
  {
    ID: 324,
    Country: "Italy",
    Language: "Italian (Italy)",
    TwoLetterISORegionName: "IT",
    ThreeLetterISORegionName: "ITA",
    TwoLetterISOLanguageName: "it",
    ThreeLetterISOLanguageName: "ita",
    CultureInfo: "it-IT",
  },
  {
    ID: 325,
    Country: "San Marino",
    Language: "Italian (San Marino)",
    TwoLetterISORegionName: "SM",
    ThreeLetterISORegionName: "SMR",
    TwoLetterISOLanguageName: "it",
    ThreeLetterISOLanguageName: "ita",
    CultureInfo: "it-SM",
  },
  {
    ID: 326,
    Country: "Vatican City",
    Language: "Italian (Vatican City)",
    TwoLetterISORegionName: "VA",
    ThreeLetterISORegionName: "VAT",
    TwoLetterISOLanguageName: "it",
    ThreeLetterISOLanguageName: "ita",
    CultureInfo: "it-VA",
  },
  {
    ID: 327,
    Country: "Canada",
    Language: "Inuktitut (Canada)",
    TwoLetterISORegionName: "CA",
    ThreeLetterISORegionName: "CAN",
    TwoLetterISOLanguageName: "iu",
    ThreeLetterISOLanguageName: "iku",
    CultureInfo: "iu-CA",
  },
  {
    ID: 328,
    Country: "Canada",
    Language: "Inuktitut (Latin, Canada)",
    TwoLetterISORegionName: "CA",
    ThreeLetterISORegionName: "CAN",
    TwoLetterISOLanguageName: "iu",
    ThreeLetterISOLanguageName: "iku",
    CultureInfo: "iu-Latn-CA",
  },
  {
    ID: 329,
    Country: "Japan",
    Language: "Japanese (Japan)",
    TwoLetterISORegionName: "JP",
    ThreeLetterISORegionName: "JPN",
    TwoLetterISOLanguageName: "ja",
    ThreeLetterISOLanguageName: "jpn",
    CultureInfo: "ja-JP",
  },
  {
    ID: 330,
    Country: "Cameroon",
    Language: "Ngomba (Cameroon)",
    TwoLetterISORegionName: "CM",
    ThreeLetterISORegionName: "CMR",
    TwoLetterISOLanguageName: "jgo",
    ThreeLetterISOLanguageName: "jgo",
    CultureInfo: "jgo-CM",
  },
  {
    ID: 331,
    Country: "Tanzania",
    Language: "Machame (Tanzania)",
    TwoLetterISORegionName: "TZ",
    ThreeLetterISORegionName: "TZA",
    TwoLetterISOLanguageName: "jmc",
    ThreeLetterISOLanguageName: "jmc",
    CultureInfo: "jmc-TZ",
  },
  {
    ID: 332,
    Country: "Indonesia",
    Language: "Javanese (Indonesia)",
    TwoLetterISORegionName: "ID",
    ThreeLetterISORegionName: "IDN",
    TwoLetterISOLanguageName: "jv",
    ThreeLetterISOLanguageName: "jav",
    CultureInfo: "jv-ID",
  },
  {
    ID: 333,
    Country: "Georgia",
    Language: "Georgian (Georgia)",
    TwoLetterISORegionName: "GE",
    ThreeLetterISORegionName: "GEO",
    TwoLetterISOLanguageName: "ka",
    ThreeLetterISOLanguageName: "kat",
    CultureInfo: "ka-GE",
  },
  {
    ID: 334,
    Country: "Algeria",
    Language: "Kabyle (Algeria)",
    TwoLetterISORegionName: "DZ",
    ThreeLetterISORegionName: "DZA",
    TwoLetterISOLanguageName: "kab",
    ThreeLetterISOLanguageName: "kab",
    CultureInfo: "kab-DZ",
  },
  {
    ID: 335,
    Country: "Kenya",
    Language: "Kamba (Kenya)",
    TwoLetterISORegionName: "KE",
    ThreeLetterISORegionName: "KEN",
    TwoLetterISOLanguageName: "kam",
    ThreeLetterISOLanguageName: "kam",
    CultureInfo: "kam-KE",
  },
  {
    ID: 336,
    Country: "Tanzania",
    Language: "Makonde (Tanzania)",
    TwoLetterISORegionName: "TZ",
    ThreeLetterISORegionName: "TZA",
    TwoLetterISOLanguageName: "kde",
    ThreeLetterISOLanguageName: "kde",
    CultureInfo: "kde-TZ",
  },
  {
    ID: 337,
    Country: "Cabo Verde",
    Language: "Kabuverdianu (Cabo Verde)",
    TwoLetterISORegionName: "CV",
    ThreeLetterISORegionName: "CPV",
    TwoLetterISOLanguageName: "kea",
    ThreeLetterISOLanguageName: "kea",
    CultureInfo: "kea-CV",
  },
  {
    ID: 338,
    Country: "Mali",
    Language: "Koyra Chiini (Mali)",
    TwoLetterISORegionName: "ML",
    ThreeLetterISORegionName: "MLI",
    TwoLetterISOLanguageName: "khq",
    ThreeLetterISOLanguageName: "khq",
    CultureInfo: "khq-ML",
  },
  {
    ID: 339,
    Country: "Kenya",
    Language: "Kikuyu (Kenya)",
    TwoLetterISORegionName: "KE",
    ThreeLetterISORegionName: "KEN",
    TwoLetterISOLanguageName: "ki",
    ThreeLetterISOLanguageName: "kik",
    CultureInfo: "ki-KE",
  },
  {
    ID: 340,
    Country: "Kazakhstan",
    Language: "Kazakh (Kazakhstan)",
    TwoLetterISORegionName: "KZ",
    ThreeLetterISORegionName: "KAZ",
    TwoLetterISOLanguageName: "kk",
    ThreeLetterISOLanguageName: "kaz",
    CultureInfo: "kk-KZ",
  },
  {
    ID: 341,
    Country: "Cameroon",
    Language: "Kako (Cameroon)",
    TwoLetterISORegionName: "CM",
    ThreeLetterISORegionName: "CMR",
    TwoLetterISOLanguageName: "kkj",
    ThreeLetterISOLanguageName: "kkj",
    CultureInfo: "kkj-CM",
  },
  {
    ID: 342,
    Country: "Greenland",
    Language: "Kalaallisut (Greenland)",
    TwoLetterISORegionName: "GL",
    ThreeLetterISORegionName: "GRL",
    TwoLetterISOLanguageName: "kl",
    ThreeLetterISOLanguageName: "kal",
    CultureInfo: "kl-GL",
  },
  {
    ID: 343,
    Country: "Kenya",
    Language: "Kalenjin (Kenya)",
    TwoLetterISORegionName: "KE",
    ThreeLetterISORegionName: "KEN",
    TwoLetterISOLanguageName: "kln",
    ThreeLetterISOLanguageName: "kln",
    CultureInfo: "kln-KE",
  },
  {
    ID: 344,
    Country: "Cambodia",
    Language: "Khmer (Cambodia)",
    TwoLetterISORegionName: "KH",
    ThreeLetterISORegionName: "KHM",
    TwoLetterISOLanguageName: "km",
    ThreeLetterISOLanguageName: "khm",
    CultureInfo: "km-KH",
  },
  {
    ID: 345,
    Country: "India",
    Language: "Kannada (India)",
    TwoLetterISORegionName: "IN",
    ThreeLetterISORegionName: "IND",
    TwoLetterISOLanguageName: "kn",
    ThreeLetterISOLanguageName: "kan",
    CultureInfo: "kn-IN",
  },
  {
    ID: 346,
    Country: "North Korea",
    Language: "Korean (North Korea)",
    TwoLetterISORegionName: "KP",
    ThreeLetterISORegionName: "PRK",
    TwoLetterISOLanguageName: "ko",
    ThreeLetterISOLanguageName: "kor",
    CultureInfo: "ko-KP",
  },
  {
    ID: 347,
    Country: "Korea",
    Language: "Korean (Korea)",
    TwoLetterISORegionName: "KR",
    ThreeLetterISORegionName: "KOR",
    TwoLetterISOLanguageName: "ko",
    ThreeLetterISOLanguageName: "kor",
    CultureInfo: "ko-KR",
  },
  {
    ID: 348,
    Country: "India",
    Language: "Konkani (India)",
    TwoLetterISORegionName: "IN",
    ThreeLetterISORegionName: "IND",
    TwoLetterISOLanguageName: "kok",
    ThreeLetterISOLanguageName: "kok",
    CultureInfo: "kok-IN",
  },
  {
    ID: 349,
    Country: "India",
    Language: "Kashmiri (India)",
    TwoLetterISORegionName: "IN",
    ThreeLetterISORegionName: "IND",
    TwoLetterISOLanguageName: "ks",
    ThreeLetterISOLanguageName: "kas",
    CultureInfo: "ks-IN",
  },
  {
    ID: 350,
    Country: "Tanzania",
    Language: "Shambala (Tanzania)",
    TwoLetterISORegionName: "TZ",
    ThreeLetterISORegionName: "TZA",
    TwoLetterISOLanguageName: "ksb",
    ThreeLetterISOLanguageName: "ksb",
    CultureInfo: "ksb-TZ",
  },
  {
    ID: 351,
    Country: "Cameroon",
    Language: "Bafia (Cameroon)",
    TwoLetterISORegionName: "CM",
    ThreeLetterISORegionName: "CMR",
    TwoLetterISOLanguageName: "ksf",
    ThreeLetterISOLanguageName: "ksf",
    CultureInfo: "ksf-CM",
  },
  {
    ID: 352,
    Country: "Germany",
    Language: "Colognian (Germany)",
    TwoLetterISORegionName: "DE",
    ThreeLetterISORegionName: "DEU",
    TwoLetterISOLanguageName: "ksh",
    ThreeLetterISOLanguageName: "ksh",
    CultureInfo: "ksh-DE",
  },
  {
    ID: 353,
    Country: "United Kingdom",
    Language: "Cornish (United Kingdom)",
    TwoLetterISORegionName: "GB",
    ThreeLetterISORegionName: "GBR",
    TwoLetterISOLanguageName: "kw",
    ThreeLetterISOLanguageName: "cor",
    CultureInfo: "kw-GB",
  },
  {
    ID: 354,
    Country: "Kyrgyzstan",
    Language: "Kyrgyz (Kyrgyzstan)",
    TwoLetterISORegionName: "KG",
    ThreeLetterISORegionName: "KGZ",
    TwoLetterISOLanguageName: "ky",
    ThreeLetterISOLanguageName: "kir",
    CultureInfo: "ky-KG",
  },
  {
    ID: 355,
    Country: "Tanzania",
    Language: "Langi (Tanzania)",
    TwoLetterISORegionName: "TZ",
    ThreeLetterISORegionName: "TZA",
    TwoLetterISOLanguageName: "lag",
    ThreeLetterISOLanguageName: "lag",
    CultureInfo: "lag-TZ",
  },
  {
    ID: 356,
    Country: "Luxembourg",
    Language: "Luxembourgish (Luxembourg)",
    TwoLetterISORegionName: "LU",
    ThreeLetterISORegionName: "LUX",
    TwoLetterISOLanguageName: "lb",
    ThreeLetterISOLanguageName: "ltz",
    CultureInfo: "lb-LU",
  },
  {
    ID: 357,
    Country: "Uganda",
    Language: "Ganda (Uganda)",
    TwoLetterISORegionName: "UG",
    ThreeLetterISORegionName: "UGA",
    TwoLetterISOLanguageName: "lg",
    ThreeLetterISOLanguageName: "lug",
    CultureInfo: "lg-UG",
  },
  {
    ID: 358,
    Country: "United States",
    Language: "Lakota (United States)",
    TwoLetterISORegionName: "US",
    ThreeLetterISORegionName: "USA",
    TwoLetterISOLanguageName: "lkt",
    ThreeLetterISOLanguageName: "lkt",
    CultureInfo: "lkt-US",
  },
  {
    ID: 359,
    Country: "Angola",
    Language: "Lingala (Angola)",
    TwoLetterISORegionName: "AO",
    ThreeLetterISORegionName: "AGO",
    TwoLetterISOLanguageName: "ln",
    ThreeLetterISOLanguageName: "lin",
    CultureInfo: "ln-AO",
  },
  {
    ID: 360,
    Country: "Congo (DRC)",
    Language: "Lingala (Congo [DRC])",
    TwoLetterISORegionName: "CD",
    ThreeLetterISORegionName: "COD",
    TwoLetterISOLanguageName: "ln",
    ThreeLetterISOLanguageName: "lin",
    CultureInfo: "ln-CD",
  },
  {
    ID: 361,
    Country: "Central African Republic",
    Language: "Lingala (Central African Republic)",
    TwoLetterISORegionName: "CF",
    ThreeLetterISORegionName: "CAF",
    TwoLetterISOLanguageName: "ln",
    ThreeLetterISOLanguageName: "lin",
    CultureInfo: "ln-CF",
  },
  {
    ID: 362,
    Country: "Congo",
    Language: "Lingala (Congo)",
    TwoLetterISORegionName: "CG",
    ThreeLetterISORegionName: "COG",
    TwoLetterISOLanguageName: "ln",
    ThreeLetterISOLanguageName: "lin",
    CultureInfo: "ln-CG",
  },
  {
    ID: 363,
    Country: "Laos",
    Language: "Lao (Laos)",
    TwoLetterISORegionName: "LA",
    ThreeLetterISORegionName: "LAO",
    TwoLetterISOLanguageName: "lo",
    ThreeLetterISOLanguageName: "lao",
    CultureInfo: "lo-LA",
  },
  {
    ID: 364,
    Country: "Iraq",
    Language: "Northern Luri (Iraq)",
    TwoLetterISORegionName: "IQ",
    ThreeLetterISORegionName: "IRQ",
    TwoLetterISOLanguageName: "lrc",
    ThreeLetterISOLanguageName: "lrc",
    CultureInfo: "lrc-IQ",
  },
  {
    ID: 365,
    Country: "Iran",
    Language: "Northern Luri (Iran)",
    TwoLetterISORegionName: "IR",
    ThreeLetterISORegionName: "IRN",
    TwoLetterISOLanguageName: "lrc",
    ThreeLetterISOLanguageName: "lrc",
    CultureInfo: "lrc-IR",
  },
  {
    ID: 366,
    Country: "Lithuania",
    Language: "Lithuanian (Lithuania)",
    TwoLetterISORegionName: "LT",
    ThreeLetterISORegionName: "LTU",
    TwoLetterISOLanguageName: "lt",
    ThreeLetterISOLanguageName: "lit",
    CultureInfo: "lt-LT",
  },
  {
    ID: 367,
    Country: "Congo (DRC)",
    Language: "Luba-Katanga (Congo [DRC])",
    TwoLetterISORegionName: "CD",
    ThreeLetterISORegionName: "COD",
    TwoLetterISOLanguageName: "lu",
    ThreeLetterISOLanguageName: "lub",
    CultureInfo: "lu-CD",
  },
  {
    ID: 368,
    Country: "Kenya",
    Language: "Luo (Kenya)",
    TwoLetterISORegionName: "KE",
    ThreeLetterISORegionName: "KEN",
    TwoLetterISOLanguageName: "luo",
    ThreeLetterISOLanguageName: "luo",
    CultureInfo: "luo-KE",
  },
  {
    ID: 369,
    Country: "Kenya",
    Language: "Luyia (Kenya)",
    TwoLetterISORegionName: "KE",
    ThreeLetterISORegionName: "KEN",
    TwoLetterISOLanguageName: "luy",
    ThreeLetterISOLanguageName: "luy",
    CultureInfo: "luy-KE",
  },
  {
    ID: 370,
    Country: "Latvia",
    Language: "Latvian (Latvia)",
    TwoLetterISORegionName: "LV",
    ThreeLetterISORegionName: "LVA",
    TwoLetterISOLanguageName: "lv",
    ThreeLetterISOLanguageName: "lav",
    CultureInfo: "lv-LV",
  },
  {
    ID: 371,
    Country: "Kenya",
    Language: "Masai (Kenya)",
    TwoLetterISORegionName: "KE",
    ThreeLetterISORegionName: "KEN",
    TwoLetterISOLanguageName: "mas",
    ThreeLetterISOLanguageName: "mas",
    CultureInfo: "mas-KE",
  },
  {
    ID: 372,
    Country: "Tanzania",
    Language: "Masai (Tanzania)",
    TwoLetterISORegionName: "TZ",
    ThreeLetterISORegionName: "TZA",
    TwoLetterISOLanguageName: "mas",
    ThreeLetterISOLanguageName: "mas",
    CultureInfo: "mas-TZ",
  },
  {
    ID: 373,
    Country: "Kenya",
    Language: "Meru (Kenya)",
    TwoLetterISORegionName: "KE",
    ThreeLetterISORegionName: "KEN",
    TwoLetterISOLanguageName: "mer",
    ThreeLetterISOLanguageName: "mer",
    CultureInfo: "mer-KE",
  },
  {
    ID: 374,
    Country: "Mauritius",
    Language: "Morisyen (Mauritius)",
    TwoLetterISORegionName: "MU",
    ThreeLetterISORegionName: "MUS",
    TwoLetterISOLanguageName: "mfe",
    ThreeLetterISOLanguageName: "mfe",
    CultureInfo: "mfe-MU",
  },
  {
    ID: 375,
    Country: "Madagascar",
    Language: "Malagasy (Madagascar)",
    TwoLetterISORegionName: "MG",
    ThreeLetterISORegionName: "MDG",
    TwoLetterISOLanguageName: "mg",
    ThreeLetterISOLanguageName: "mlg",
    CultureInfo: "mg-MG",
  },
  {
    ID: 376,
    Country: "Mozambique",
    Language: "Makhuwa-Meetto (Mozambique)",
    TwoLetterISORegionName: "MZ",
    ThreeLetterISORegionName: "MOZ",
    TwoLetterISOLanguageName: "mgh",
    ThreeLetterISOLanguageName: "mgh",
    CultureInfo: "mgh-MZ",
  },
  {
    ID: 377,
    Country: "Cameroon",
    Language: "Metaʼ (Cameroon)",
    TwoLetterISORegionName: "CM",
    ThreeLetterISORegionName: "CMR",
    TwoLetterISOLanguageName: "mgo",
    ThreeLetterISOLanguageName: "mgo",
    CultureInfo: "mgo-CM",
  },
  {
    ID: 378,
    Country: "New Zealand",
    Language: "Maori (New Zealand)",
    TwoLetterISORegionName: "NZ",
    ThreeLetterISORegionName: "NZL",
    TwoLetterISOLanguageName: "mi",
    ThreeLetterISOLanguageName: "mri",
    CultureInfo: "mi-NZ",
  },
  {
    ID: 379,
    Country: "North Macedonia",
    Language: "Macedonian (North Macedonia)",
    TwoLetterISORegionName: "MK",
    ThreeLetterISORegionName: "MKD",
    TwoLetterISOLanguageName: "mk",
    ThreeLetterISOLanguageName: "mkd",
    CultureInfo: "mk-MK",
  },
  {
    ID: 380,
    Country: "India",
    Language: "Malayalam (India)",
    TwoLetterISORegionName: "IN",
    ThreeLetterISORegionName: "IND",
    TwoLetterISOLanguageName: "ml",
    ThreeLetterISOLanguageName: "mal",
    CultureInfo: "ml-IN",
  },
  {
    ID: 381,
    Country: "Mongolia",
    Language: "Mongolian (Mongolia)",
    TwoLetterISORegionName: "MN",
    ThreeLetterISORegionName: "MNG",
    TwoLetterISOLanguageName: "mn",
    ThreeLetterISOLanguageName: "mon",
    CultureInfo: "mn-MN",
  },
  {
    ID: 382,
    Country: "China",
    Language: "Mongolian (Mongolian, China)",
    TwoLetterISORegionName: "CN",
    ThreeLetterISORegionName: "CHN",
    TwoLetterISOLanguageName: "mn",
    ThreeLetterISOLanguageName: "mon",
    CultureInfo: "mn-Mong-CN",
  },
  {
    ID: 383,
    Country: "Mongolia",
    Language: "Mongolian (Mongolian, Mongolia)",
    TwoLetterISORegionName: "MN",
    ThreeLetterISORegionName: "MNG",
    TwoLetterISOLanguageName: "mn",
    ThreeLetterISOLanguageName: "mon",
    CultureInfo: "mn-Mong-MN",
  },
  {
    ID: 384,
    Country: "Canada",
    Language: "Mohawk (Canada)",
    TwoLetterISORegionName: "CA",
    ThreeLetterISORegionName: "CAN",
    TwoLetterISOLanguageName: "moh",
    ThreeLetterISOLanguageName: "moh",
    CultureInfo: "moh-CA",
  },
  {
    ID: 385,
    Country: "India",
    Language: "Marathi (India)",
    TwoLetterISORegionName: "IN",
    ThreeLetterISORegionName: "IND",
    TwoLetterISOLanguageName: "mr",
    ThreeLetterISOLanguageName: "mar",
    CultureInfo: "mr-IN",
  },
  {
    ID: 386,
    Country: "Brunei",
    Language: "Malay (Brunei)",
    TwoLetterISORegionName: "BN",
    ThreeLetterISORegionName: "BRN",
    TwoLetterISOLanguageName: "ms",
    ThreeLetterISOLanguageName: "msa",
    CultureInfo: "ms-BN",
  },
  {
    ID: 387,
    Country: "Malaysia",
    Language: "Malay (Malaysia)",
    TwoLetterISORegionName: "MY",
    ThreeLetterISORegionName: "MYS",
    TwoLetterISOLanguageName: "ms",
    ThreeLetterISOLanguageName: "msa",
    CultureInfo: "ms-MY",
  },
  {
    ID: 388,
    Country: "Singapore",
    Language: "Malay (Singapore)",
    TwoLetterISORegionName: "SG",
    ThreeLetterISORegionName: "SGP",
    TwoLetterISOLanguageName: "ms",
    ThreeLetterISOLanguageName: "msa",
    CultureInfo: "ms-SG",
  },
  {
    ID: 389,
    Country: "Malta",
    Language: "Maltese (Malta)",
    TwoLetterISORegionName: "MT",
    ThreeLetterISORegionName: "MLT",
    TwoLetterISOLanguageName: "mt",
    ThreeLetterISOLanguageName: "mlt",
    CultureInfo: "mt-MT",
  },
  {
    ID: 390,
    Country: "Cameroon",
    Language: "Mundang (Cameroon)",
    TwoLetterISORegionName: "CM",
    ThreeLetterISORegionName: "CMR",
    TwoLetterISOLanguageName: "mua",
    ThreeLetterISOLanguageName: "mua",
    CultureInfo: "mua-CM",
  },
  {
    ID: 391,
    Country: "Myanmar",
    Language: "Burmese (Myanmar)",
    TwoLetterISORegionName: "MM",
    ThreeLetterISORegionName: "MMR",
    TwoLetterISOLanguageName: "my",
    ThreeLetterISOLanguageName: "mya",
    CultureInfo: "my-MM",
  },
  {
    ID: 392,
    Country: "Iran",
    Language: "Mazanderani (Iran)",
    TwoLetterISORegionName: "IR",
    ThreeLetterISORegionName: "IRN",
    TwoLetterISOLanguageName: "mzn",
    ThreeLetterISOLanguageName: "mzn",
    CultureInfo: "mzn-IR",
  },
  {
    ID: 393,
    Country: "Namibia",
    Language: "Nama (Namibia)",
    TwoLetterISORegionName: "NA",
    ThreeLetterISORegionName: "NAM",
    TwoLetterISOLanguageName: "naq",
    ThreeLetterISOLanguageName: "naq",
    CultureInfo: "naq-NA",
  },
  {
    ID: 394,
    Country: "Norway",
    Language: "Norwegian Bokm&#229;l (Norway)",
    TwoLetterISORegionName: "NO",
    ThreeLetterISORegionName: "NOR",
    TwoLetterISOLanguageName: "nb",
    ThreeLetterISOLanguageName: "nob",
    CultureInfo: "nb-NO",
  },
  {
    ID: 395,
    Country: "Svalbard &amp; Jan Mayen",
    Language: "Norwegian Bokm&#229;l (Svalbard &amp; Jan Mayen)",
    TwoLetterISORegionName: "SJ",
    ThreeLetterISORegionName: "SJM",
    TwoLetterISOLanguageName: "nb",
    ThreeLetterISOLanguageName: "nob",
    CultureInfo: "nb-SJ",
  },
  {
    ID: 396,
    Country: "Zimbabwe",
    Language: "North Ndebele (Zimbabwe)",
    TwoLetterISORegionName: "ZW",
    ThreeLetterISORegionName: "ZWE",
    TwoLetterISOLanguageName: "nd",
    ThreeLetterISOLanguageName: "nde",
    CultureInfo: "nd-ZW",
  },
  {
    ID: 397,
    Country: "Germany",
    Language: "Low German (Germany)",
    TwoLetterISORegionName: "DE",
    ThreeLetterISORegionName: "DEU",
    TwoLetterISOLanguageName: "nds",
    ThreeLetterISOLanguageName: "nds",
    CultureInfo: "nds-DE",
  },
  {
    ID: 398,
    Country: "Netherlands",
    Language: "Low German (Netherlands)",
    TwoLetterISORegionName: "NL",
    ThreeLetterISORegionName: "NLD",
    TwoLetterISOLanguageName: "nds",
    ThreeLetterISOLanguageName: "nds",
    CultureInfo: "nds-NL",
  },
  {
    ID: 399,
    Country: "India",
    Language: "Nepali (India)",
    TwoLetterISORegionName: "IN",
    ThreeLetterISORegionName: "IND",
    TwoLetterISOLanguageName: "ne",
    ThreeLetterISOLanguageName: "nep",
    CultureInfo: "ne-IN",
  },
  {
    ID: 400,
    Country: "Nepal",
    Language: "Nepali (Nepal)",
    TwoLetterISORegionName: "NP",
    ThreeLetterISORegionName: "NPL",
    TwoLetterISOLanguageName: "ne",
    ThreeLetterISOLanguageName: "nep",
    CultureInfo: "ne-NP",
  },
  {
    ID: 401,
    Country: "Aruba",
    Language: "Dutch (Aruba)",
    TwoLetterISORegionName: "AW",
    ThreeLetterISORegionName: "ABW",
    TwoLetterISOLanguageName: "nl",
    ThreeLetterISOLanguageName: "nld",
    CultureInfo: "nl-AW",
  },
  {
    ID: 402,
    Country: "Belgium",
    Language: "Dutch (Belgium)",
    TwoLetterISORegionName: "BE",
    ThreeLetterISORegionName: "BEL",
    TwoLetterISOLanguageName: "nl",
    ThreeLetterISOLanguageName: "nld",
    CultureInfo: "nl-BE",
  },
  {
    ID: 403,
    Country: "Bonaire, Sint Eustatius and Saba",
    Language: "Dutch (Bonaire, Sint Eustatius and Saba)",
    TwoLetterISORegionName: "BQ",
    ThreeLetterISORegionName: "BES",
    TwoLetterISOLanguageName: "nl",
    ThreeLetterISOLanguageName: "nld",
    CultureInfo: "nl-BQ",
  },
  {
    ID: 404,
    Country: "Cura&#231;ao",
    Language: "Dutch (Cura&#231;ao)",
    TwoLetterISORegionName: "CW",
    ThreeLetterISORegionName: "CUW",
    TwoLetterISOLanguageName: "nl",
    ThreeLetterISOLanguageName: "nld",
    CultureInfo: "nl-CW",
  },
  {
    ID: 405,
    Country: "Netherlands",
    Language: "Dutch (Netherlands)",
    TwoLetterISORegionName: "NL",
    ThreeLetterISORegionName: "NLD",
    TwoLetterISOLanguageName: "nl",
    ThreeLetterISOLanguageName: "nld",
    CultureInfo: "nl-NL",
  },
  {
    ID: 406,
    Country: "Suriname",
    Language: "Dutch (Suriname)",
    TwoLetterISORegionName: "SR",
    ThreeLetterISORegionName: "SUR",
    TwoLetterISOLanguageName: "nl",
    ThreeLetterISOLanguageName: "nld",
    CultureInfo: "nl-SR",
  },
  {
    ID: 407,
    Country: "Sint Maarten",
    Language: "Dutch (Sint Maarten)",
    TwoLetterISORegionName: "SX",
    ThreeLetterISORegionName: "SXM",
    TwoLetterISOLanguageName: "nl",
    ThreeLetterISOLanguageName: "nld",
    CultureInfo: "nl-SX",
  },
  {
    ID: 408,
    Country: "Cameroon",
    Language: "Kwasio (Cameroon)",
    TwoLetterISORegionName: "CM",
    ThreeLetterISORegionName: "CMR",
    TwoLetterISOLanguageName: "nmg",
    ThreeLetterISOLanguageName: "nmg",
    CultureInfo: "nmg-CM",
  },
  {
    ID: 409,
    Country: "Norway",
    Language: "Norwegian Nynorsk (Norway)",
    TwoLetterISORegionName: "NO",
    ThreeLetterISORegionName: "NOR",
    TwoLetterISOLanguageName: "nn",
    ThreeLetterISOLanguageName: "nno",
    CultureInfo: "nn-NO",
  },
  {
    ID: 410,
    Country: "Cameroon",
    Language: "Ngiemboon (Cameroon)",
    TwoLetterISORegionName: "CM",
    ThreeLetterISORegionName: "CMR",
    TwoLetterISOLanguageName: "nnh",
    ThreeLetterISOLanguageName: "nnh",
    CultureInfo: "nnh-CM",
  },
  {
    ID: 411,
    Country: "Guinea",
    Language: "N’Ko (Guinea)",
    TwoLetterISORegionName: "GN",
    ThreeLetterISORegionName: "GIN",
    TwoLetterISOLanguageName: "nqo",
    ThreeLetterISOLanguageName: "nqo",
    CultureInfo: "nqo-GN",
  },
  {
    ID: 412,
    Country: "South Africa",
    Language: "South Ndebele (South Africa)",
    TwoLetterISORegionName: "ZA",
    ThreeLetterISORegionName: "ZAF",
    TwoLetterISOLanguageName: "nr",
    ThreeLetterISOLanguageName: "nbl",
    CultureInfo: "nr-ZA",
  },
  {
    ID: 413,
    Country: "South Africa",
    Language: "Sesotho sa Leboa (South Africa)",
    TwoLetterISORegionName: "ZA",
    ThreeLetterISORegionName: "ZAF",
    TwoLetterISOLanguageName: "nso",
    ThreeLetterISOLanguageName: "nso",
    CultureInfo: "nso-ZA",
  },
  {
    ID: 414,
    Country: "South Sudan",
    Language: "Nuer (South Sudan)",
    TwoLetterISORegionName: "SS",
    ThreeLetterISORegionName: "SSD",
    TwoLetterISOLanguageName: "nus",
    ThreeLetterISOLanguageName: "nus",
    CultureInfo: "nus-SS",
  },
  {
    ID: 415,
    Country: "Uganda",
    Language: "Nyankole (Uganda)",
    TwoLetterISORegionName: "UG",
    ThreeLetterISORegionName: "UGA",
    TwoLetterISOLanguageName: "nyn",
    ThreeLetterISOLanguageName: "nyn",
    CultureInfo: "nyn-UG",
  },
  {
    ID: 416,
    Country: "France",
    Language: "Occitan (France)",
    TwoLetterISORegionName: "FR",
    ThreeLetterISORegionName: "FRA",
    TwoLetterISOLanguageName: "oc",
    ThreeLetterISOLanguageName: "oci",
    CultureInfo: "oc-FR",
  },
  {
    ID: 417,
    Country: "Ethiopia",
    Language: "Oromo (Ethiopia)",
    TwoLetterISORegionName: "ET",
    ThreeLetterISORegionName: "ETH",
    TwoLetterISOLanguageName: "om",
    ThreeLetterISOLanguageName: "orm",
    CultureInfo: "om-ET",
  },
  {
    ID: 418,
    Country: "Kenya",
    Language: "Oromo (Kenya)",
    TwoLetterISORegionName: "KE",
    ThreeLetterISORegionName: "KEN",
    TwoLetterISOLanguageName: "om",
    ThreeLetterISOLanguageName: "orm",
    CultureInfo: "om-KE",
  },
  {
    ID: 419,
    Country: "India",
    Language: "Odia (India)",
    TwoLetterISORegionName: "IN",
    ThreeLetterISORegionName: "IND",
    TwoLetterISOLanguageName: "or",
    ThreeLetterISOLanguageName: "ori",
    CultureInfo: "or-IN",
  },
  {
    ID: 420,
    Country: "Georgia",
    Language: "Ossetic (Georgia)",
    TwoLetterISORegionName: "GE",
    ThreeLetterISORegionName: "GEO",
    TwoLetterISOLanguageName: "os",
    ThreeLetterISOLanguageName: "oss",
    CultureInfo: "os-GE",
  },
  {
    ID: 421,
    Country: "Russia",
    Language: "Ossetic (Russia)",
    TwoLetterISORegionName: "RU",
    ThreeLetterISORegionName: "RUS",
    TwoLetterISOLanguageName: "os",
    ThreeLetterISOLanguageName: "oss",
    CultureInfo: "os-RU",
  },
  {
    ID: 422,
    Country: "Pakistan",
    Language: "Punjabi (Arabic, Pakistan)",
    TwoLetterISORegionName: "PK",
    ThreeLetterISORegionName: "PAK",
    TwoLetterISOLanguageName: "pa",
    ThreeLetterISOLanguageName: "pan",
    CultureInfo: "pa-Arab-PK",
  },
  {
    ID: 423,
    Country: "India",
    Language: "Punjabi (Gurmukhi, India)",
    TwoLetterISORegionName: "IN",
    ThreeLetterISORegionName: "IND",
    TwoLetterISOLanguageName: "pa",
    ThreeLetterISOLanguageName: "pan",
    CultureInfo: "pa-Guru-IN",
  },
  {
    ID: 424,
    Country: "Poland",
    Language: "Polish (Poland)",
    TwoLetterISORegionName: "PL",
    ThreeLetterISORegionName: "POL",
    TwoLetterISOLanguageName: "pl",
    ThreeLetterISOLanguageName: "pol",
    CultureInfo: "pl-PL",
  },
  {
    ID: 425,
    Country: "World",
    Language: "Prussian (World)",
    TwoLetterISORegionName: "001",
    ThreeLetterISORegionName: "",
    TwoLetterISOLanguageName: "prg",
    ThreeLetterISOLanguageName: "prg",
    CultureInfo: "prg-001",
  },
  {
    ID: 426,
    Country: "Afghanistan",
    Language: "Pashto (Afghanistan)",
    TwoLetterISORegionName: "AF",
    ThreeLetterISORegionName: "AFG",
    TwoLetterISOLanguageName: "ps",
    ThreeLetterISOLanguageName: "pus",
    CultureInfo: "ps-AF",
  },
  {
    ID: 427,
    Country: "Pakistan",
    Language: "Pashto (Pakistan)",
    TwoLetterISORegionName: "PK",
    ThreeLetterISORegionName: "PAK",
    TwoLetterISOLanguageName: "ps",
    ThreeLetterISOLanguageName: "pus",
    CultureInfo: "ps-PK",
  },
  {
    ID: 428,
    Country: "Angola",
    Language: "Portuguese (Angola)",
    TwoLetterISORegionName: "AO",
    ThreeLetterISORegionName: "AGO",
    TwoLetterISOLanguageName: "pt",
    ThreeLetterISOLanguageName: "por",
    CultureInfo: "pt-AO",
  },
  {
    ID: 429,
    Country: "Brazil",
    Language: "Portuguese (Brazil)",
    TwoLetterISORegionName: "BR",
    ThreeLetterISORegionName: "BRA",
    TwoLetterISOLanguageName: "pt",
    ThreeLetterISOLanguageName: "por",
    CultureInfo: "pt-BR",
  },
  {
    ID: 430,
    Country: "Switzerland",
    Language: "Portuguese (Switzerland)",
    TwoLetterISORegionName: "CH",
    ThreeLetterISORegionName: "CHE",
    TwoLetterISOLanguageName: "pt",
    ThreeLetterISOLanguageName: "por",
    CultureInfo: "pt-CH",
  },
  {
    ID: 431,
    Country: "Cabo Verde",
    Language: "Portuguese (Cabo Verde)",
    TwoLetterISORegionName: "CV",
    ThreeLetterISORegionName: "CPV",
    TwoLetterISOLanguageName: "pt",
    ThreeLetterISOLanguageName: "por",
    CultureInfo: "pt-CV",
  },
  {
    ID: 432,
    Country: "Equatorial Guinea",
    Language: "Portuguese (Equatorial Guinea)",
    TwoLetterISORegionName: "GQ",
    ThreeLetterISORegionName: "GNQ",
    TwoLetterISOLanguageName: "pt",
    ThreeLetterISOLanguageName: "por",
    CultureInfo: "pt-GQ",
  },
  {
    ID: 433,
    Country: "Guinea-Bissau",
    Language: "Portuguese (Guinea-Bissau)",
    TwoLetterISORegionName: "GW",
    ThreeLetterISORegionName: "GNB",
    TwoLetterISOLanguageName: "pt",
    ThreeLetterISOLanguageName: "por",
    CultureInfo: "pt-GW",
  },
  {
    ID: 434,
    Country: "Luxembourg",
    Language: "Portuguese (Luxembourg)",
    TwoLetterISORegionName: "LU",
    ThreeLetterISORegionName: "LUX",
    TwoLetterISOLanguageName: "pt",
    ThreeLetterISOLanguageName: "por",
    CultureInfo: "pt-LU",
  },
  {
    ID: 435,
    Country: "Macao SAR",
    Language: "Portuguese (Macao SAR)",
    TwoLetterISORegionName: "MO",
    ThreeLetterISORegionName: "MAC",
    TwoLetterISOLanguageName: "pt",
    ThreeLetterISOLanguageName: "por",
    CultureInfo: "pt-MO",
  },
  {
    ID: 436,
    Country: "Mozambique",
    Language: "Portuguese (Mozambique)",
    TwoLetterISORegionName: "MZ",
    ThreeLetterISORegionName: "MOZ",
    TwoLetterISOLanguageName: "pt",
    ThreeLetterISOLanguageName: "por",
    CultureInfo: "pt-MZ",
  },
  {
    ID: 437,
    Country: "Portugal",
    Language: "Portuguese (Portugal)",
    TwoLetterISORegionName: "PT",
    ThreeLetterISORegionName: "PRT",
    TwoLetterISOLanguageName: "pt",
    ThreeLetterISOLanguageName: "por",
    CultureInfo: "pt-PT",
  },
  {
    ID: 438,
    Country: "S&#227;o Tom&#233; &amp; Pr&#237;ncipe",
    Language: "Portuguese (S&#227;o Tom&#233; &amp; Pr&#237;ncipe)",
    TwoLetterISORegionName: "ST",
    ThreeLetterISORegionName: "STP",
    TwoLetterISOLanguageName: "pt",
    ThreeLetterISOLanguageName: "por",
    CultureInfo: "pt-ST",
  },
  {
    ID: 439,
    Country: "Timor-Leste",
    Language: "Portuguese (Timor-Leste)",
    TwoLetterISORegionName: "TL",
    ThreeLetterISORegionName: "TLS",
    TwoLetterISOLanguageName: "pt",
    ThreeLetterISOLanguageName: "por",
    CultureInfo: "pt-TL",
  },
  {
    ID: 440,
    Country: "Bolivia",
    Language: "Quechua (Bolivia)",
    TwoLetterISORegionName: "BO",
    ThreeLetterISORegionName: "BOL",
    TwoLetterISOLanguageName: "qu",
    ThreeLetterISOLanguageName: "que",
    CultureInfo: "qu-BO",
  },
  {
    ID: 441,
    Country: "Ecuador",
    Language: "Quechua (Ecuador)",
    TwoLetterISORegionName: "EC",
    ThreeLetterISORegionName: "ECU",
    TwoLetterISOLanguageName: "qu",
    ThreeLetterISOLanguageName: "que",
    CultureInfo: "qu-EC",
  },
  {
    ID: 442,
    Country: "Peru",
    Language: "Quechua (Peru)",
    TwoLetterISORegionName: "PE",
    ThreeLetterISORegionName: "PER",
    TwoLetterISOLanguageName: "qu",
    ThreeLetterISOLanguageName: "que",
    CultureInfo: "qu-PE",
  },
  {
    ID: 443,
    Country: "Guatemala",
    Language: "Kʼicheʼ (Guatemala)",
    TwoLetterISORegionName: "GT",
    ThreeLetterISORegionName: "GTM",
    TwoLetterISOLanguageName: "quc",
    ThreeLetterISOLanguageName: "quc",
    CultureInfo: "quc-GT",
  },
  {
    ID: 444,
    Country: "Switzerland",
    Language: "Romansh (Switzerland)",
    TwoLetterISORegionName: "CH",
    ThreeLetterISORegionName: "CHE",
    TwoLetterISOLanguageName: "rm",
    ThreeLetterISOLanguageName: "roh",
    CultureInfo: "rm-CH",
  },
  {
    ID: 445,
    Country: "Burundi",
    Language: "Rundi (Burundi)",
    TwoLetterISORegionName: "BI",
    ThreeLetterISORegionName: "BDI",
    TwoLetterISOLanguageName: "rn",
    ThreeLetterISOLanguageName: "run",
    CultureInfo: "rn-BI",
  },
  {
    ID: 446,
    Country: "Moldova",
    Language: "Romanian (Moldova)",
    TwoLetterISORegionName: "MD",
    ThreeLetterISORegionName: "MDA",
    TwoLetterISOLanguageName: "ro",
    ThreeLetterISOLanguageName: "ron",
    CultureInfo: "ro-MD",
  },
  {
    ID: 447,
    Country: "Romania",
    Language: "Romanian (Romania)",
    TwoLetterISORegionName: "RO",
    ThreeLetterISORegionName: "ROU",
    TwoLetterISOLanguageName: "ro",
    ThreeLetterISOLanguageName: "ron",
    CultureInfo: "ro-RO",
  },
  {
    ID: 448,
    Country: "Tanzania",
    Language: "Rombo (Tanzania)",
    TwoLetterISORegionName: "TZ",
    ThreeLetterISORegionName: "TZA",
    TwoLetterISOLanguageName: "rof",
    ThreeLetterISOLanguageName: "rof",
    CultureInfo: "rof-TZ",
  },
  {
    ID: 449,
    Country: "Belarus",
    Language: "Russian (Belarus)",
    TwoLetterISORegionName: "BY",
    ThreeLetterISORegionName: "BLR",
    TwoLetterISOLanguageName: "ru",
    ThreeLetterISOLanguageName: "rus",
    CultureInfo: "ru-BY",
  },
  {
    ID: 450,
    Country: "Kyrgyzstan",
    Language: "Russian (Kyrgyzstan)",
    TwoLetterISORegionName: "KG",
    ThreeLetterISORegionName: "KGZ",
    TwoLetterISOLanguageName: "ru",
    ThreeLetterISOLanguageName: "rus",
    CultureInfo: "ru-KG",
  },
  {
    ID: 451,
    Country: "Kazakhstan",
    Language: "Russian (Kazakhstan)",
    TwoLetterISORegionName: "KZ",
    ThreeLetterISORegionName: "KAZ",
    TwoLetterISOLanguageName: "ru",
    ThreeLetterISOLanguageName: "rus",
    CultureInfo: "ru-KZ",
  },
  {
    ID: 452,
    Country: "Moldova",
    Language: "Russian (Moldova)",
    TwoLetterISORegionName: "MD",
    ThreeLetterISORegionName: "MDA",
    TwoLetterISOLanguageName: "ru",
    ThreeLetterISOLanguageName: "rus",
    CultureInfo: "ru-MD",
  },
  {
    ID: 453,
    Country: "Russia",
    Language: "Russian (Russia)",
    TwoLetterISORegionName: "RU",
    ThreeLetterISORegionName: "RUS",
    TwoLetterISOLanguageName: "ru",
    ThreeLetterISOLanguageName: "rus",
    CultureInfo: "ru-RU",
  },
  {
    ID: 454,
    Country: "Ukraine",
    Language: "Russian (Ukraine)",
    TwoLetterISORegionName: "UA",
    ThreeLetterISORegionName: "UKR",
    TwoLetterISOLanguageName: "ru",
    ThreeLetterISOLanguageName: "rus",
    CultureInfo: "ru-UA",
  },
  {
    ID: 455,
    Country: "Rwanda",
    Language: "Kinyarwanda (Rwanda)",
    TwoLetterISORegionName: "RW",
    ThreeLetterISORegionName: "RWA",
    TwoLetterISOLanguageName: "rw",
    ThreeLetterISOLanguageName: "kin",
    CultureInfo: "rw-RW",
  },
  {
    ID: 456,
    Country: "Tanzania",
    Language: "Rwa (Tanzania)",
    TwoLetterISORegionName: "TZ",
    ThreeLetterISORegionName: "TZA",
    TwoLetterISOLanguageName: "rwk",
    ThreeLetterISOLanguageName: "rwk",
    CultureInfo: "rwk-TZ",
  },
  {
    ID: 457,
    Country: "India",
    Language: "Sanskrit (India)",
    TwoLetterISORegionName: "IN",
    ThreeLetterISORegionName: "IND",
    TwoLetterISOLanguageName: "sa",
    ThreeLetterISOLanguageName: "san",
    CultureInfo: "sa-IN",
  },
  {
    ID: 458,
    Country: "Russia",
    Language: "Sakha (Russia)",
    TwoLetterISORegionName: "RU",
    ThreeLetterISORegionName: "RUS",
    TwoLetterISOLanguageName: "sah",
    ThreeLetterISOLanguageName: "sah",
    CultureInfo: "sah-RU",
  },
  {
    ID: 459,
    Country: "Kenya",
    Language: "Samburu (Kenya)",
    TwoLetterISORegionName: "KE",
    ThreeLetterISORegionName: "KEN",
    TwoLetterISOLanguageName: "saq",
    ThreeLetterISOLanguageName: "saq",
    CultureInfo: "saq-KE",
  },
  {
    ID: 460,
    Country: "Tanzania",
    Language: "Sangu (Tanzania)",
    TwoLetterISORegionName: "TZ",
    ThreeLetterISORegionName: "TZA",
    TwoLetterISOLanguageName: "sbp",
    ThreeLetterISOLanguageName: "sbp",
    CultureInfo: "sbp-TZ",
  },
  {
    ID: 461,
    Country: "Pakistan",
    Language: "Sindhi (Pakistan)",
    TwoLetterISORegionName: "PK",
    ThreeLetterISORegionName: "PAK",
    TwoLetterISOLanguageName: "sd",
    ThreeLetterISOLanguageName: "snd",
    CultureInfo: "sd-PK",
  },
  {
    ID: 462,
    Country: "Finland",
    Language: "Northern Sami (Finland)",
    TwoLetterISORegionName: "FI",
    ThreeLetterISORegionName: "FIN",
    TwoLetterISOLanguageName: "se",
    ThreeLetterISOLanguageName: "sme",
    CultureInfo: "se-FI",
  },
  {
    ID: 463,
    Country: "Norway",
    Language: "Northern Sami (Norway)",
    TwoLetterISORegionName: "NO",
    ThreeLetterISORegionName: "NOR",
    TwoLetterISOLanguageName: "se",
    ThreeLetterISOLanguageName: "sme",
    CultureInfo: "se-NO",
  },
  {
    ID: 464,
    Country: "Sweden",
    Language: "Northern Sami (Sweden)",
    TwoLetterISORegionName: "SE",
    ThreeLetterISORegionName: "SWE",
    TwoLetterISOLanguageName: "se",
    ThreeLetterISOLanguageName: "sme",
    CultureInfo: "se-SE",
  },
  {
    ID: 465,
    Country: "Mozambique",
    Language: "Sena (Mozambique)",
    TwoLetterISORegionName: "MZ",
    ThreeLetterISORegionName: "MOZ",
    TwoLetterISOLanguageName: "seh",
    ThreeLetterISOLanguageName: "seh",
    CultureInfo: "seh-MZ",
  },
  {
    ID: 466,
    Country: "Mali",
    Language: "Koyraboro Senni (Mali)",
    TwoLetterISORegionName: "ML",
    ThreeLetterISORegionName: "MLI",
    TwoLetterISOLanguageName: "ses",
    ThreeLetterISOLanguageName: "ses",
    CultureInfo: "ses-ML",
  },
  {
    ID: 467,
    Country: "Central African Republic",
    Language: "Sango (Central African Republic)",
    TwoLetterISORegionName: "CF",
    ThreeLetterISORegionName: "CAF",
    TwoLetterISOLanguageName: "sg",
    ThreeLetterISOLanguageName: "sag",
    CultureInfo: "sg-CF",
  },
  {
    ID: 468,
    Country: "Morocco",
    Language: "Tachelhit (Latin, Morocco)",
    TwoLetterISORegionName: "MA",
    ThreeLetterISORegionName: "MAR",
    TwoLetterISOLanguageName: "shi",
    ThreeLetterISOLanguageName: "shi",
    CultureInfo: "shi-Latn-MA",
  },
  {
    ID: 469,
    Country: "Morocco",
    Language: "Tachelhit (Tifinagh, Morocco)",
    TwoLetterISORegionName: "MA",
    ThreeLetterISORegionName: "MAR",
    TwoLetterISOLanguageName: "shi",
    ThreeLetterISOLanguageName: "shi",
    CultureInfo: "shi-Tfng-MA",
  },
  {
    ID: 470,
    Country: "Sri Lanka",
    Language: "Sinhala (Sri Lanka)",
    TwoLetterISORegionName: "LK",
    ThreeLetterISORegionName: "LKA",
    TwoLetterISOLanguageName: "si",
    ThreeLetterISOLanguageName: "sin",
    CultureInfo: "si-LK",
  },
  {
    ID: 471,
    Country: "Slovakia",
    Language: "Slovak (Slovakia)",
    TwoLetterISORegionName: "SK",
    ThreeLetterISORegionName: "SVK",
    TwoLetterISOLanguageName: "sk",
    ThreeLetterISOLanguageName: "slk",
    CultureInfo: "sk-SK",
  },
  {
    ID: 472,
    Country: "Slovenia",
    Language: "Slovenian (Slovenia)",
    TwoLetterISORegionName: "SI",
    ThreeLetterISORegionName: "SVN",
    TwoLetterISOLanguageName: "sl",
    ThreeLetterISOLanguageName: "slv",
    CultureInfo: "sl-SI",
  },
  {
    ID: 473,
    Country: "Norway",
    Language: "Southern Sami (Norway)",
    TwoLetterISORegionName: "NO",
    ThreeLetterISORegionName: "NOR",
    TwoLetterISOLanguageName: "sma",
    ThreeLetterISOLanguageName: "sma",
    CultureInfo: "sma-NO",
  },
  {
    ID: 474,
    Country: "Sweden",
    Language: "Southern Sami (Sweden)",
    TwoLetterISORegionName: "SE",
    ThreeLetterISORegionName: "SWE",
    TwoLetterISOLanguageName: "sma",
    ThreeLetterISOLanguageName: "sma",
    CultureInfo: "sma-SE",
  },
  {
    ID: 475,
    Country: "Norway",
    Language: "Lule Sami (Norway)",
    TwoLetterISORegionName: "NO",
    ThreeLetterISORegionName: "NOR",
    TwoLetterISOLanguageName: "smj",
    ThreeLetterISOLanguageName: "smj",
    CultureInfo: "smj-NO",
  },
  {
    ID: 476,
    Country: "Sweden",
    Language: "Lule Sami (Sweden)",
    TwoLetterISORegionName: "SE",
    ThreeLetterISORegionName: "SWE",
    TwoLetterISOLanguageName: "smj",
    ThreeLetterISOLanguageName: "smj",
    CultureInfo: "smj-SE",
  },
  {
    ID: 477,
    Country: "Finland",
    Language: "Inari Sami (Finland)",
    TwoLetterISORegionName: "FI",
    ThreeLetterISORegionName: "FIN",
    TwoLetterISOLanguageName: "smn",
    ThreeLetterISOLanguageName: "smn",
    CultureInfo: "smn-FI",
  },
  {
    ID: 478,
    Country: "Finland",
    Language: "Skolt Sami (Finland)",
    TwoLetterISORegionName: "FI",
    ThreeLetterISORegionName: "FIN",
    TwoLetterISOLanguageName: "sms",
    ThreeLetterISOLanguageName: "sms",
    CultureInfo: "sms-FI",
  },
  {
    ID: 479,
    Country: "Zimbabwe",
    Language: "Shona (Zimbabwe)",
    TwoLetterISORegionName: "ZW",
    ThreeLetterISORegionName: "ZWE",
    TwoLetterISOLanguageName: "sn",
    ThreeLetterISOLanguageName: "sna",
    CultureInfo: "sn-ZW",
  },
  {
    ID: 480,
    Country: "Djibouti",
    Language: "Somali (Djibouti)",
    TwoLetterISORegionName: "DJ",
    ThreeLetterISORegionName: "DJI",
    TwoLetterISOLanguageName: "so",
    ThreeLetterISOLanguageName: "som",
    CultureInfo: "so-DJ",
  },
  {
    ID: 481,
    Country: "Ethiopia",
    Language: "Somali (Ethiopia)",
    TwoLetterISORegionName: "ET",
    ThreeLetterISORegionName: "ETH",
    TwoLetterISOLanguageName: "so",
    ThreeLetterISOLanguageName: "som",
    CultureInfo: "so-ET",
  },
  {
    ID: 482,
    Country: "Kenya",
    Language: "Somali (Kenya)",
    TwoLetterISORegionName: "KE",
    ThreeLetterISORegionName: "KEN",
    TwoLetterISOLanguageName: "so",
    ThreeLetterISOLanguageName: "som",
    CultureInfo: "so-KE",
  },
  {
    ID: 483,
    Country: "Somalia",
    Language: "Somali (Somalia)",
    TwoLetterISORegionName: "SO",
    ThreeLetterISORegionName: "SOM",
    TwoLetterISOLanguageName: "so",
    ThreeLetterISOLanguageName: "som",
    CultureInfo: "so-SO",
  },
  {
    ID: 484,
    Country: "Albania",
    Language: "Albanian (Albania)",
    TwoLetterISORegionName: "AL",
    ThreeLetterISORegionName: "ALB",
    TwoLetterISOLanguageName: "sq",
    ThreeLetterISOLanguageName: "sqi",
    CultureInfo: "sq-AL",
  },
  {
    ID: 485,
    Country: "North Macedonia",
    Language: "Albanian (North Macedonia)",
    TwoLetterISORegionName: "MK",
    ThreeLetterISORegionName: "MKD",
    TwoLetterISOLanguageName: "sq",
    ThreeLetterISOLanguageName: "sqi",
    CultureInfo: "sq-MK",
  },
  {
    ID: 486,
    Country: "Kosovo",
    Language: "Albanian (Kosovo)",
    TwoLetterISORegionName: "XK",
    ThreeLetterISORegionName: "",
    TwoLetterISOLanguageName: "sq",
    ThreeLetterISOLanguageName: "sqi",
    CultureInfo: "sq-XK",
  },
  {
    ID: 487,
    Country: "Bosnia &amp; Herzegovina",
    Language: "Serbian (Cyrillic, Bosnia &amp; Herzegovina)",
    TwoLetterISORegionName: "BA",
    ThreeLetterISORegionName: "BIH",
    TwoLetterISOLanguageName: "sr",
    ThreeLetterISOLanguageName: "srp",
    CultureInfo: "sr-Cyrl-BA",
  },
  {
    ID: 488,
    Country: "Montenegro",
    Language: "Serbian (Cyrillic, Montenegro)",
    TwoLetterISORegionName: "ME",
    ThreeLetterISORegionName: "MNE",
    TwoLetterISOLanguageName: "sr",
    ThreeLetterISOLanguageName: "srp",
    CultureInfo: "sr-Cyrl-ME",
  },
  {
    ID: 489,
    Country: "Serbia",
    Language: "Serbian (Cyrillic, Serbia)",
    TwoLetterISORegionName: "RS",
    ThreeLetterISORegionName: "SRB",
    TwoLetterISOLanguageName: "sr",
    ThreeLetterISOLanguageName: "srp",
    CultureInfo: "sr-Cyrl-RS",
  },
  {
    ID: 490,
    Country: "Kosovo",
    Language: "Serbian (Cyrillic, Kosovo)",
    TwoLetterISORegionName: "XK",
    ThreeLetterISORegionName: "",
    TwoLetterISOLanguageName: "sr",
    ThreeLetterISOLanguageName: "srp",
    CultureInfo: "sr-Cyrl-XK",
  },
  {
    ID: 491,
    Country: "Bosnia &amp; Herzegovina",
    Language: "Serbian (Latin, Bosnia &amp; Herzegovina)",
    TwoLetterISORegionName: "BA",
    ThreeLetterISORegionName: "BIH",
    TwoLetterISOLanguageName: "sr",
    ThreeLetterISOLanguageName: "srp",
    CultureInfo: "sr-Latn-BA",
  },
  {
    ID: 492,
    Country: "Montenegro",
    Language: "Serbian (Latin, Montenegro)",
    TwoLetterISORegionName: "ME",
    ThreeLetterISORegionName: "MNE",
    TwoLetterISOLanguageName: "sr",
    ThreeLetterISOLanguageName: "srp",
    CultureInfo: "sr-Latn-ME",
  },
  {
    ID: 493,
    Country: "Serbia",
    Language: "Serbian (Latin, Serbia)",
    TwoLetterISORegionName: "RS",
    ThreeLetterISORegionName: "SRB",
    TwoLetterISOLanguageName: "sr",
    ThreeLetterISOLanguageName: "srp",
    CultureInfo: "sr-Latn-RS",
  },
  {
    ID: 494,
    Country: "Kosovo",
    Language: "Serbian (Latin, Kosovo)",
    TwoLetterISORegionName: "XK",
    ThreeLetterISORegionName: "",
    TwoLetterISOLanguageName: "sr",
    ThreeLetterISOLanguageName: "srp",
    CultureInfo: "sr-Latn-XK",
  },
  {
    ID: 495,
    Country: "Eswatini",
    Language: "siSwati (Eswatini)",
    TwoLetterISORegionName: "SZ",
    ThreeLetterISORegionName: "SWZ",
    TwoLetterISOLanguageName: "ss",
    ThreeLetterISOLanguageName: "ssw",
    CultureInfo: "ss-SZ",
  },
  {
    ID: 496,
    Country: "South Africa",
    Language: "siSwati (South Africa)",
    TwoLetterISORegionName: "ZA",
    ThreeLetterISORegionName: "ZAF",
    TwoLetterISOLanguageName: "ss",
    ThreeLetterISOLanguageName: "ssw",
    CultureInfo: "ss-ZA",
  },
  {
    ID: 497,
    Country: "Eritrea",
    Language: "Saho (Eritrea)",
    TwoLetterISORegionName: "ER",
    ThreeLetterISORegionName: "ERI",
    TwoLetterISOLanguageName: "ssy",
    ThreeLetterISOLanguageName: "ssy",
    CultureInfo: "ssy-ER",
  },
  {
    ID: 498,
    Country: "Lesotho",
    Language: "Sesotho (Lesotho)",
    TwoLetterISORegionName: "LS",
    ThreeLetterISORegionName: "LSO",
    TwoLetterISOLanguageName: "st",
    ThreeLetterISOLanguageName: "sot",
    CultureInfo: "st-LS",
  },
  {
    ID: 499,
    Country: "South Africa",
    Language: "Sesotho (South Africa)",
    TwoLetterISORegionName: "ZA",
    ThreeLetterISORegionName: "ZAF",
    TwoLetterISOLanguageName: "st",
    ThreeLetterISOLanguageName: "sot",
    CultureInfo: "st-ZA",
  },
  {
    ID: 500,
    Country: "&#197;land Islands",
    Language: "Swedish (&#197;land Islands)",
    TwoLetterISORegionName: "AX",
    ThreeLetterISORegionName: "ALA",
    TwoLetterISOLanguageName: "sv",
    ThreeLetterISOLanguageName: "swe",
    CultureInfo: "sv-AX",
  },
  {
    ID: 501,
    Country: "Finland",
    Language: "Swedish (Finland)",
    TwoLetterISORegionName: "FI",
    ThreeLetterISORegionName: "FIN",
    TwoLetterISOLanguageName: "sv",
    ThreeLetterISOLanguageName: "swe",
    CultureInfo: "sv-FI",
  },
  {
    ID: 502,
    Country: "Sweden",
    Language: "Swedish (Sweden)",
    TwoLetterISORegionName: "SE",
    ThreeLetterISORegionName: "SWE",
    TwoLetterISOLanguageName: "sv",
    ThreeLetterISOLanguageName: "swe",
    CultureInfo: "sv-SE",
  },
  {
    ID: 503,
    Country: "Congo (DRC)",
    Language: "Kiswahili (Congo [DRC])",
    TwoLetterISORegionName: "CD",
    ThreeLetterISORegionName: "COD",
    TwoLetterISOLanguageName: "sw",
    ThreeLetterISOLanguageName: "swa",
    CultureInfo: "sw-CD",
  },
  {
    ID: 504,
    Country: "Kenya",
    Language: "Kiswahili (Kenya)",
    TwoLetterISORegionName: "KE",
    ThreeLetterISORegionName: "KEN",
    TwoLetterISOLanguageName: "sw",
    ThreeLetterISOLanguageName: "swa",
    CultureInfo: "sw-KE",
  },
  {
    ID: 505,
    Country: "Tanzania",
    Language: "Kiswahili (Tanzania)",
    TwoLetterISORegionName: "TZ",
    ThreeLetterISORegionName: "TZA",
    TwoLetterISOLanguageName: "sw",
    ThreeLetterISOLanguageName: "swa",
    CultureInfo: "sw-TZ",
  },
  {
    ID: 506,
    Country: "Uganda",
    Language: "Kiswahili (Uganda)",
    TwoLetterISORegionName: "UG",
    ThreeLetterISORegionName: "UGA",
    TwoLetterISOLanguageName: "sw",
    ThreeLetterISOLanguageName: "swa",
    CultureInfo: "sw-UG",
  },
  {
    ID: 507,
    Country: "Syria",
    Language: "Syriac (Syria)",
    TwoLetterISORegionName: "SY",
    ThreeLetterISORegionName: "SYR",
    TwoLetterISOLanguageName: "syr",
    ThreeLetterISOLanguageName: "syr",
    CultureInfo: "syr-SY",
  },
  {
    ID: 508,
    Country: "India",
    Language: "Tamil (India)",
    TwoLetterISORegionName: "IN",
    ThreeLetterISORegionName: "IND",
    TwoLetterISOLanguageName: "ta",
    ThreeLetterISOLanguageName: "tam",
    CultureInfo: "ta-IN",
  },
  {
    ID: 509,
    Country: "Sri Lanka",
    Language: "Tamil (Sri Lanka)",
    TwoLetterISORegionName: "LK",
    ThreeLetterISORegionName: "LKA",
    TwoLetterISOLanguageName: "ta",
    ThreeLetterISOLanguageName: "tam",
    CultureInfo: "ta-LK",
  },
  {
    ID: 510,
    Country: "Malaysia",
    Language: "Tamil (Malaysia)",
    TwoLetterISORegionName: "MY",
    ThreeLetterISORegionName: "MYS",
    TwoLetterISOLanguageName: "ta",
    ThreeLetterISOLanguageName: "tam",
    CultureInfo: "ta-MY",
  },
  {
    ID: 511,
    Country: "Singapore",
    Language: "Tamil (Singapore)",
    TwoLetterISORegionName: "SG",
    ThreeLetterISORegionName: "SGP",
    TwoLetterISOLanguageName: "ta",
    ThreeLetterISOLanguageName: "tam",
    CultureInfo: "ta-SG",
  },
  {
    ID: 512,
    Country: "India",
    Language: "Telugu (India)",
    TwoLetterISORegionName: "IN",
    ThreeLetterISORegionName: "IND",
    TwoLetterISOLanguageName: "te",
    ThreeLetterISOLanguageName: "tel",
    CultureInfo: "te-IN",
  },
  {
    ID: 513,
    Country: "Kenya",
    Language: "Teso (Kenya)",
    TwoLetterISORegionName: "KE",
    ThreeLetterISORegionName: "KEN",
    TwoLetterISOLanguageName: "teo",
    ThreeLetterISOLanguageName: "teo",
    CultureInfo: "teo-KE",
  },
  {
    ID: 514,
    Country: "Uganda",
    Language: "Teso (Uganda)",
    TwoLetterISORegionName: "UG",
    ThreeLetterISORegionName: "UGA",
    TwoLetterISOLanguageName: "teo",
    ThreeLetterISOLanguageName: "teo",
    CultureInfo: "teo-UG",
  },
  {
    ID: 515,
    Country: "Tajikistan",
    Language: "Tajik (Tajikistan)",
    TwoLetterISORegionName: "TJ",
    ThreeLetterISORegionName: "TJK",
    TwoLetterISOLanguageName: "tg",
    ThreeLetterISOLanguageName: "tgk",
    CultureInfo: "tg-TJ",
  },
  {
    ID: 516,
    Country: "Thailand",
    Language: "Thai (Thailand)",
    TwoLetterISORegionName: "TH",
    ThreeLetterISORegionName: "THA",
    TwoLetterISOLanguageName: "th",
    ThreeLetterISOLanguageName: "tha",
    CultureInfo: "th-TH",
  },
  {
    ID: 517,
    Country: "Eritrea",
    Language: "Tigrinya (Eritrea)",
    TwoLetterISORegionName: "ER",
    ThreeLetterISORegionName: "ERI",
    TwoLetterISOLanguageName: "ti",
    ThreeLetterISOLanguageName: "tir",
    CultureInfo: "ti-ER",
  },
  {
    ID: 518,
    Country: "Ethiopia",
    Language: "Tigrinya (Ethiopia)",
    TwoLetterISORegionName: "ET",
    ThreeLetterISORegionName: "ETH",
    TwoLetterISOLanguageName: "ti",
    ThreeLetterISOLanguageName: "tir",
    CultureInfo: "ti-ET",
  },
  {
    ID: 519,
    Country: "Eritrea",
    Language: "Tigre (Eritrea)",
    TwoLetterISORegionName: "ER",
    ThreeLetterISORegionName: "ERI",
    TwoLetterISOLanguageName: "tig",
    ThreeLetterISOLanguageName: "tig",
    CultureInfo: "tig-ER",
  },
  {
    ID: 520,
    Country: "Turkmenistan",
    Language: "Turkmen (Turkmenistan)",
    TwoLetterISORegionName: "TM",
    ThreeLetterISORegionName: "TKM",
    TwoLetterISOLanguageName: "tk",
    ThreeLetterISOLanguageName: "tuk",
    CultureInfo: "tk-TM",
  },
  {
    ID: 521,
    Country: "Botswana",
    Language: "Setswana (Botswana)",
    TwoLetterISORegionName: "BW",
    ThreeLetterISORegionName: "BWA",
    TwoLetterISOLanguageName: "tn",
    ThreeLetterISOLanguageName: "tsn",
    CultureInfo: "tn-BW",
  },
  {
    ID: 522,
    Country: "South Africa",
    Language: "Setswana (South Africa)",
    TwoLetterISORegionName: "ZA",
    ThreeLetterISORegionName: "ZAF",
    TwoLetterISOLanguageName: "tn",
    ThreeLetterISOLanguageName: "tsn",
    CultureInfo: "tn-ZA",
  },
  {
    ID: 523,
    Country: "Tonga",
    Language: "Tongan (Tonga)",
    TwoLetterISORegionName: "TO",
    ThreeLetterISORegionName: "TON",
    TwoLetterISOLanguageName: "to",
    ThreeLetterISOLanguageName: "ton",
    CultureInfo: "to-TO",
  },
  {
    ID: 524,
    Country: "Cyprus",
    Language: "Turkish (Cyprus)",
    TwoLetterISORegionName: "CY",
    ThreeLetterISORegionName: "CYP",
    TwoLetterISOLanguageName: "tr",
    ThreeLetterISOLanguageName: "tur",
    CultureInfo: "tr-CY",
  },
  {
    ID: 525,
    Country: "Turkey",
    Language: "Turkish (Turkey)",
    TwoLetterISORegionName: "TR",
    ThreeLetterISORegionName: "TUR",
    TwoLetterISOLanguageName: "tr",
    ThreeLetterISOLanguageName: "tur",
    CultureInfo: "tr-TR",
  },
  {
    ID: 526,
    Country: "South Africa",
    Language: "Xitsonga (South Africa)",
    TwoLetterISORegionName: "ZA",
    ThreeLetterISORegionName: "ZAF",
    TwoLetterISOLanguageName: "ts",
    ThreeLetterISOLanguageName: "tso",
    CultureInfo: "ts-ZA",
  },
  {
    ID: 527,
    Country: "Russia",
    Language: "Tatar (Russia)",
    TwoLetterISORegionName: "RU",
    ThreeLetterISORegionName: "RUS",
    TwoLetterISOLanguageName: "tt",
    ThreeLetterISOLanguageName: "tat",
    CultureInfo: "tt-RU",
  },
  {
    ID: 528,
    Country: "Niger",
    Language: "Tasawaq (Niger)",
    TwoLetterISORegionName: "NE",
    ThreeLetterISORegionName: "NER",
    TwoLetterISOLanguageName: "twq",
    ThreeLetterISOLanguageName: "twq",
    CultureInfo: "twq-NE",
  },
  {
    ID: 529,
    Country: "Morocco",
    Language: "Central Atlas Tamazight (Morocco)",
    TwoLetterISORegionName: "MA",
    ThreeLetterISORegionName: "MAR",
    TwoLetterISOLanguageName: "tzm",
    ThreeLetterISOLanguageName: "tzm",
    CultureInfo: "tzm-MA",
  },
  {
    ID: 530,
    Country: "China",
    Language: "Uyghur (China)",
    TwoLetterISORegionName: "CN",
    ThreeLetterISORegionName: "CHN",
    TwoLetterISOLanguageName: "ug",
    ThreeLetterISOLanguageName: "uig",
    CultureInfo: "ug-CN",
  },
  {
    ID: 531,
    Country: "Ukraine",
    Language: "Ukrainian (Ukraine)",
    TwoLetterISORegionName: "UA",
    ThreeLetterISORegionName: "UKR",
    TwoLetterISOLanguageName: "uk",
    ThreeLetterISOLanguageName: "ukr",
    CultureInfo: "uk-UA",
  },
  {
    ID: 532,
    Country: "India",
    Language: "Urdu (India)",
    TwoLetterISORegionName: "IN",
    ThreeLetterISORegionName: "IND",
    TwoLetterISOLanguageName: "ur",
    ThreeLetterISOLanguageName: "urd",
    CultureInfo: "ur-IN",
  },
  {
    ID: 533,
    Country: "Pakistan",
    Language: "Urdu (Pakistan)",
    TwoLetterISORegionName: "PK",
    ThreeLetterISORegionName: "PAK",
    TwoLetterISOLanguageName: "ur",
    ThreeLetterISOLanguageName: "urd",
    CultureInfo: "ur-PK",
  },
  {
    ID: 534,
    Country: "Afghanistan",
    Language: "Uzbek (Arabic, Afghanistan)",
    TwoLetterISORegionName: "AF",
    ThreeLetterISORegionName: "AFG",
    TwoLetterISOLanguageName: "uz",
    ThreeLetterISOLanguageName: "uzb",
    CultureInfo: "uz-Arab-AF",
  },
  {
    ID: 535,
    Country: "Uzbekistan",
    Language: "Uzbek (Cyrillic, Uzbekistan)",
    TwoLetterISORegionName: "UZ",
    ThreeLetterISORegionName: "UZB",
    TwoLetterISOLanguageName: "uz",
    ThreeLetterISOLanguageName: "uzb",
    CultureInfo: "uz-Cyrl-UZ",
  },
  {
    ID: 536,
    Country: "Uzbekistan",
    Language: "Uzbek (Latin, Uzbekistan)",
    TwoLetterISORegionName: "UZ",
    ThreeLetterISORegionName: "UZB",
    TwoLetterISOLanguageName: "uz",
    ThreeLetterISOLanguageName: "uzb",
    CultureInfo: "uz-Latn-UZ",
  },
  {
    ID: 537,
    Country: "Liberia",
    Language: "Vai (Latin, Liberia)",
    TwoLetterISORegionName: "LR",
    ThreeLetterISORegionName: "LBR",
    TwoLetterISOLanguageName: "vai",
    ThreeLetterISOLanguageName: "vai",
    CultureInfo: "vai-Latn-LR",
  },
  {
    ID: 538,
    Country: "Liberia",
    Language: "Vai (Vai, Liberia)",
    TwoLetterISORegionName: "LR",
    ThreeLetterISORegionName: "LBR",
    TwoLetterISOLanguageName: "vai",
    ThreeLetterISOLanguageName: "vai",
    CultureInfo: "vai-Vaii-LR",
  },
  {
    ID: 539,
    Country: "South Africa",
    Language: "Venda (South Africa)",
    TwoLetterISORegionName: "ZA",
    ThreeLetterISORegionName: "ZAF",
    TwoLetterISOLanguageName: "ve",
    ThreeLetterISOLanguageName: "ven",
    CultureInfo: "ve-ZA",
  },
  {
    ID: 540,
    Country: "Vietnam",
    Language: "Vietnamese (Vietnam)",
    TwoLetterISORegionName: "VN",
    ThreeLetterISORegionName: "VNM",
    TwoLetterISOLanguageName: "vi",
    ThreeLetterISOLanguageName: "vie",
    CultureInfo: "vi-VN",
  },
  {
    ID: 541,
    Country: "World",
    Language: "Volap&#252;k (World)",
    TwoLetterISORegionName: "001",
    ThreeLetterISORegionName: "",
    TwoLetterISOLanguageName: "vo",
    ThreeLetterISOLanguageName: "vol",
    CultureInfo: "vo-001",
  },
  {
    ID: 542,
    Country: "Tanzania",
    Language: "Vunjo (Tanzania)",
    TwoLetterISORegionName: "TZ",
    ThreeLetterISORegionName: "TZA",
    TwoLetterISOLanguageName: "vun",
    ThreeLetterISOLanguageName: "vun",
    CultureInfo: "vun-TZ",
  },
  {
    ID: 543,
    Country: "Switzerland",
    Language: "Walser (Switzerland)",
    TwoLetterISORegionName: "CH",
    ThreeLetterISORegionName: "CHE",
    TwoLetterISOLanguageName: "wae",
    ThreeLetterISOLanguageName: "wae",
    CultureInfo: "wae-CH",
  },
  {
    ID: 544,
    Country: "Ethiopia",
    Language: "Wolaytta (Ethiopia)",
    TwoLetterISORegionName: "ET",
    ThreeLetterISORegionName: "ETH",
    TwoLetterISOLanguageName: "wal",
    ThreeLetterISOLanguageName: "wal",
    CultureInfo: "wal-ET",
  },
  {
    ID: 545,
    Country: "Senegal",
    Language: "Wolof (Senegal)",
    TwoLetterISORegionName: "SN",
    ThreeLetterISORegionName: "SEN",
    TwoLetterISOLanguageName: "wo",
    ThreeLetterISOLanguageName: "wol",
    CultureInfo: "wo-SN",
  },
  {
    ID: 546,
    Country: "South Africa",
    Language: "isiXhosa (South Africa)",
    TwoLetterISORegionName: "ZA",
    ThreeLetterISORegionName: "ZAF",
    TwoLetterISOLanguageName: "xh",
    ThreeLetterISOLanguageName: "xho",
    CultureInfo: "xh-ZA",
  },
  {
    ID: 547,
    Country: "Uganda",
    Language: "Soga (Uganda)",
    TwoLetterISORegionName: "UG",
    ThreeLetterISORegionName: "UGA",
    TwoLetterISOLanguageName: "xog",
    ThreeLetterISOLanguageName: "xog",
    CultureInfo: "xog-UG",
  },
  {
    ID: 548,
    Country: "Cameroon",
    Language: "Yangben (Cameroon)",
    TwoLetterISORegionName: "CM",
    ThreeLetterISORegionName: "CMR",
    TwoLetterISOLanguageName: "yav",
    ThreeLetterISOLanguageName: "yav",
    CultureInfo: "yav-CM",
  },
  {
    ID: 549,
    Country: "World",
    Language: "Yiddish (World)",
    TwoLetterISORegionName: "001",
    ThreeLetterISORegionName: "",
    TwoLetterISOLanguageName: "yi",
    ThreeLetterISOLanguageName: "yid",
    CultureInfo: "yi-001",
  },
  {
    ID: 550,
    Country: "Benin",
    Language: "Yoruba (Benin)",
    TwoLetterISORegionName: "BJ",
    ThreeLetterISORegionName: "BEN",
    TwoLetterISOLanguageName: "yo",
    ThreeLetterISOLanguageName: "yor",
    CultureInfo: "yo-BJ",
  },
  {
    ID: 551,
    Country: "Nigeria",
    Language: "Yoruba (Nigeria)",
    TwoLetterISORegionName: "NG",
    ThreeLetterISORegionName: "NGA",
    TwoLetterISOLanguageName: "yo",
    ThreeLetterISOLanguageName: "yor",
    CultureInfo: "yo-NG",
  },
  {
    ID: 552,
    Country: "Morocco",
    Language: "Standard Moroccan Tamazight (Morocco)",
    TwoLetterISORegionName: "MA",
    ThreeLetterISORegionName: "MAR",
    TwoLetterISOLanguageName: "zgh",
    ThreeLetterISOLanguageName: "zgh",
    CultureInfo: "zgh-MA",
  },
  {
    ID: 553,
    Country: "China",
    Language: "Chinese (Simplified, China)",
    TwoLetterISORegionName: "CN",
    ThreeLetterISORegionName: "CHN",
    TwoLetterISOLanguageName: "zh",
    ThreeLetterISOLanguageName: "zho",
    CultureInfo: "zh-Hans-CN",
  },
  {
    ID: 554,
    Country: "Hong Kong SAR",
    Language: "Chinese (Simplified, Hong Kong SAR)",
    TwoLetterISORegionName: "HK",
    ThreeLetterISORegionName: "HKG",
    TwoLetterISOLanguageName: "zh",
    ThreeLetterISOLanguageName: "zho",
    CultureInfo: "zh-Hans-HK",
  },
  {
    ID: 555,
    Country: "Macao SAR",
    Language: "Chinese (Simplified, Macao SAR)",
    TwoLetterISORegionName: "MO",
    ThreeLetterISORegionName: "MAC",
    TwoLetterISOLanguageName: "zh",
    ThreeLetterISOLanguageName: "zho",
    CultureInfo: "zh-Hans-MO",
  },
  {
    ID: 556,
    Country: "Singapore",
    Language: "Chinese (Simplified, Singapore)",
    TwoLetterISORegionName: "SG",
    ThreeLetterISORegionName: "SGP",
    TwoLetterISOLanguageName: "zh",
    ThreeLetterISOLanguageName: "zho",
    CultureInfo: "zh-Hans-SG",
  },
  {
    ID: 557,
    Country: "Hong Kong SAR",
    Language: "Chinese (Traditional, Hong Kong SAR)",
    TwoLetterISORegionName: "HK",
    ThreeLetterISORegionName: "HKG",
    TwoLetterISOLanguageName: "zh",
    ThreeLetterISOLanguageName: "zho",
    CultureInfo: "zh-Hant-HK",
  },
  {
    ID: 558,
    Country: "Macao SAR",
    Language: "Chinese (Traditional, Macao SAR)",
    TwoLetterISORegionName: "MO",
    ThreeLetterISORegionName: "MAC",
    TwoLetterISOLanguageName: "zh",
    ThreeLetterISOLanguageName: "zho",
    CultureInfo: "zh-Hant-MO",
  },
  {
    ID: 559,
    Country: "Taiwan",
    Language: "Chinese (Traditional, Taiwan)",
    TwoLetterISORegionName: "TW",
    ThreeLetterISORegionName: "TWN",
    TwoLetterISOLanguageName: "zh",
    ThreeLetterISOLanguageName: "zho",
    CultureInfo: "zh-Hant-TW",
  },
  {
    ID: 560,
    Country: "South Africa",
    Language: "isiZulu (South Africa)",
    TwoLetterISORegionName: "ZA",
    ThreeLetterISORegionName: "ZAF",
    TwoLetterISOLanguageName: "zu",
    ThreeLetterISOLanguageName: "zul",
    CultureInfo: "zu-ZA",
  },
];
